var _polygon, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.46,84c0-3.6,1.89-5.75,4.51-5.75s4.52,2.15,4.52,5.75-1.91,5.75-4.52,5.75S387.46,87.58,387.46,84Zm7.83,0c0-3-1.35-4.68-3.32-4.68S388.64,81,388.64,84,390,88.66,392,88.66,395.29,87,395.29,84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.15,84c0-3.6,1.89-5.75,4.51-5.75s4.52,2.15,4.52,5.75-1.9,5.75-4.52,5.75S398.15,87.58,398.15,84ZM406,84c0-3-1.36-4.68-3.33-4.68S399.33,81,399.33,84s1.36,4.69,3.33,4.69S406,87,406,84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.94,78.32V89.63h-1.16V79.35h-2.67v-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.64,84c0-3.6,1.89-5.75,4.51-5.75s4.52,2.15,4.52,5.75-1.9,5.75-4.52,5.75S414.64,87.58,414.64,84Zm7.84,0c0-3-1.36-4.68-3.33-4.68S415.82,81,415.82,84s1.36,4.69,3.33,4.69S422.48,87,422.48,84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.44,78.32V89.63h-1.17V79.35h-2.66v-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.32,100c0-3.61,1.9-5.75,4.51-5.75s4.53,2.14,4.53,5.75-1.91,5.75-4.53,5.75S376.32,103.62,376.32,100Zm7.84,0c0-3-1.35-4.69-3.33-4.69S377.5,97,377.5,100s1.36,4.68,3.33,4.68S384.16,103,384.16,100Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,100c0-3.61,1.89-5.75,4.51-5.75s4.52,2.14,4.52,5.75-1.91,5.75-4.52,5.75S387,103.62,387,100Zm7.84,0c0-3-1.36-4.69-3.33-4.69S388.2,97,388.2,100s1.35,4.68,3.33,4.68S394.86,103,394.86,100Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.81,94.36v11.31h-1.16V95.4H397v-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.51,100c0-3.61,1.89-5.75,4.51-5.75s4.52,2.14,4.52,5.75-1.9,5.75-4.52,5.75S403.51,103.62,403.51,100Zm7.84,0c0-3-1.36-4.69-3.33-4.69S404.69,97,404.69,100s1.36,4.68,3.33,4.68S411.35,103,411.35,100Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.3,94.36v11.31h-1.16V95.4h-2.67v-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.14,94.36v11.31H422V95.4h-2.66v-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.83,100c0-3.61,1.89-5.75,4.51-5.75s4.52,2.14,4.52,5.75-1.9,5.75-4.52,5.75S425.83,103.62,425.83,100Zm7.84,0c0-3-1.36-4.69-3.33-4.69S427,97,427,100s1.36,4.68,3.33,4.68S433.67,103,433.67,100Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.63,94.36v11.31h-1.17V95.4H435.8v-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.46,115.53c0-3.6,1.89-5.75,4.51-5.75s4.52,2.15,4.52,5.75-1.9,5.76-4.52,5.76S387.46,119.14,387.46,115.53Zm7.84,0c0-3-1.36-4.68-3.33-4.68s-3.33,1.66-3.33,4.68,1.36,4.69,3.33,4.69S395.3,118.56,395.3,115.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.25,109.88v11.31h-1.16V110.91h-2.67v-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.09,109.88v11.31h-1.17V110.91h-2.66v-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.92,109.88v11.31h-1.17V110.91h-2.66v-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.61,115.53c0-3.6,1.89-5.75,4.51-5.75s4.52,2.15,4.52,5.75-1.9,5.76-4.52,5.76S415.61,119.14,415.61,115.53Zm7.84,0c0-3-1.36-4.68-3.33-4.68s-3.33,1.66-3.33,4.68,1.36,4.69,3.33,4.69S423.45,118.56,423.45,115.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.41,109.88v11.31h-1.17V110.91h-2.66v-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.56,203.72c0,.09-12.88.16-28.77.16S75,203.81,75,203.72s12.88-.17,28.77-.17S132.56,203.63,132.56,203.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.56,208.82c0,.09-12.88.16-28.77.16S75,208.91,75,208.82s12.88-.17,28.77-.17S132.56,208.73,132.56,208.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.06,213.92a1.88,1.88,0,0,1-.38,0l-1.07,0-4,.05-13.1.05L80.44,214l-4-.05-1.07,0a1.88,1.88,0,0,1-.38,0l.38,0,1.07,0,4,0,13.1-.05,13.1.05,4,0,1.07,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.9,227.21c0-.13.41-.24.92-.24s.92.11.92.24-.41.24-.92.24S137.9,227.35,137.9,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.2,227.21c0-.13.41-.24.92-.24s.93.11.93.24-.42.24-.93.24S134.2,227.35,134.2,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5,227.21c0-.13.42-.24.93-.24s.92.11.92.24-.41.24-.92.24S130.5,227.35,130.5,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81,227.21c0-.13.41-.24.92-.24s.93.11.93.24-.42.24-.93.24S126.81,227.35,126.81,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.11,227.21c0-.13.42-.24.93-.24s.92.11.92.24-.41.24-.92.24S123.11,227.35,123.11,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.42,227.21c0-.13.41-.24.92-.24s.92.11.92.24-.41.24-.92.24S119.42,227.35,119.42,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,227.21c0-.13.41-.24.92-.24s.93.11.93.24-.41.24-.93.24S115.72,227.35,115.72,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,227.21c0-.13.42-.24.93-.24s.92.11.92.24-.41.24-.92.24S112,227.35,112,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,227.21c0-.13.41-.24.92-.24s.93.11.93.24-.42.24-.93.24S108.33,227.35,108.33,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.63,227.21c0-.13.42-.24.93-.24s.92.11.92.24-.41.24-.92.24S104.63,227.35,104.63,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94,227.21c0-.13.41-.24.92-.24s.93.11.93.24-.42.24-.93.24S100.94,227.35,100.94,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.24,227.21c0-.13.42-.24.93-.24s.92.11.92.24-.41.24-.92.24S97.24,227.35,97.24,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.55,227.21c0-.13.41-.24.92-.24s.92.11.92.24-.41.24-.92.24S93.55,227.35,93.55,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.85,227.21c0-.13.41-.24.92-.24s.93.11.93.24-.42.24-.93.24S89.85,227.35,89.85,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.15,227.21c0-.13.42-.24.93-.24s.92.11.92.24-.41.24-.92.24S86.15,227.35,86.15,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.46,227.21c0-.13.41-.24.92-.24s.93.11.93.24-.42.24-.93.24S82.46,227.35,82.46,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.76,227.21c0-.13.42-.24.93-.24s.92.11.92.24-.41.24-.92.24S78.76,227.35,78.76,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.07,227.21c0-.13.41-.24.92-.24s.92.11.92.24-.41.24-.92.24S75.07,227.35,75.07,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.37,227.21c0-.13.41-.24.92-.24s.93.11.93.24-.42.24-.93.24S71.37,227.35,71.37,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67,227.21c0-.13.42-.24.93-.24s.92.11.92.24-.41.24-.92.24S67.67,227.35,67.67,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,227.21c0-.13.41-.24.92-.24s.93.11.93.24-.42.24-.93.24S64,227.35,64,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.28,227.21c0-.13.42-.24.93-.24s.92.11.92.24-.41.24-.92.24S60.28,227.35,60.28,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.59,227.21c0-.13.41-.24.92-.24s.93.11.93.24-.42.24-.93.24S56.59,227.35,56.59,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.89,227.21c0-.13.42-.24.93-.24s.92.11.92.24-.41.24-.92.24S52.89,227.35,52.89,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2,227.21c0-.13.41-.24.92-.24s.92.11.92.24-.41.24-.92.24S49.2,227.35,49.2,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5,227.21c0-.13.41-.24.92-.24s.93.11.93.24-.42.24-.93.24S45.5,227.35,45.5,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8,227.21c0-.13.42-.24.93-.24s.92.11.92.24-.41.24-.92.24S41.8,227.35,41.8,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.11,227.21c0-.13.41-.24.92-.24s.93.11.93.24-.42.24-.93.24S38.11,227.35,38.11,227.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,225.53c.13,0,.24.41.24.92a2.11,2.11,0,0,1-.11.76l-.13-.13c.1,0,.16.08.16.13s-.06.1-.16.14l-.08,0-.06-.17a2.4,2.4,0,0,1-.1-.76C35.86,225.94,36,225.53,36.1,225.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,221.83c.13,0,.24.42.24.93s-.11.92-.24.92-.24-.41-.24-.92S36,221.83,36.1,221.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,218.14c.13,0,.24.41.24.92s-.11.92-.24.92-.24-.41-.24-.92S36,218.14,36.1,218.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,214.44c.13,0,.24.41.24.92s-.11.93-.24.93-.24-.41-.24-.93S36,214.44,36.1,214.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,210.74c.13,0,.24.42.24.93s-.11.92-.24.92-.24-.41-.24-.92S36,210.74,36.1,210.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,207.05c.13,0,.24.41.24.92s-.11.93-.24.93-.24-.42-.24-.93S36,207.05,36.1,207.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,203.35c.13,0,.24.42.24.93s-.11.92-.24.92-.24-.41-.24-.92S36,203.35,36.1,203.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,199.66c.13,0,.24.41.24.92s-.11.93-.24.93-.24-.42-.24-.93S36,199.66,36.1,199.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,196c.13,0,.24.42.24.93s-.11.92-.24.92-.24-.41-.24-.92S36,196,36.1,196Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,192.27c.13,0,.24.41.24.92s-.11.92-.24.92-.24-.41-.24-.92S36,192.27,36.1,192.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,188.57c.13,0,.24.41.24.92s-.11.93-.24.93-.24-.42-.24-.93S36,188.57,36.1,188.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9,185.68c0,.12-.35.22-.8.24l.23-.24v.12c0,.51-.11.92-.24.92s-.24-.41-.24-.92v-.37h.24C36.55,185.46,36.9,185.56,36.9,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6,185.68c0,.13-.42.24-.93.24s-.92-.11-.92-.24.41-.24.92-.24S40.6,185.55,40.6,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.29,185.68c0,.13-.41.24-.92.24s-.93-.11-.93-.24.42-.24.93-.24S44.29,185.55,44.29,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,185.68c0,.13-.42.24-.93.24s-.92-.11-.92-.24.41-.24.92-.24S48,185.55,48,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.68,185.68c0,.13-.41.24-.92.24s-.92-.11-.92-.24.41-.24.92-.24S51.68,185.55,51.68,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.38,185.68c0,.13-.41.24-.92.24s-.93-.11-.93-.24.42-.24.93-.24S55.38,185.55,55.38,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.08,185.68c0,.13-.42.24-.93.24s-.92-.11-.92-.24.41-.24.92-.24S59.08,185.55,59.08,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.77,185.68c0,.13-.41.24-.92.24s-.93-.11-.93-.24.42-.24.93-.24S62.77,185.55,62.77,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.47,185.68c0,.13-.42.24-.93.24s-.92-.11-.92-.24.41-.24.92-.24S66.47,185.55,66.47,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.16,185.68c0,.13-.41.24-.92.24s-.92-.11-.92-.24.41-.24.92-.24S70.16,185.55,70.16,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.86,185.68c0,.13-.41.24-.92.24s-.93-.11-.93-.24.42-.24.93-.24S73.86,185.55,73.86,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.56,185.68c0,.13-.42.24-.93.24s-.92-.11-.92-.24.41-.24.92-.24S77.56,185.55,77.56,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25,185.68c0,.13-.41.24-.92.24s-.93-.11-.93-.24.42-.24.93-.24S81.25,185.55,81.25,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,185.68c0,.13-.42.24-.93.24s-.92-.11-.92-.24.41-.24.92-.24S85,185.55,85,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,185.68c0,.13-.41.24-.92.24s-.93-.11-.93-.24.42-.24.93-.24S88.64,185.55,88.64,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.34,185.68c0,.13-.42.24-.93.24s-.92-.11-.92-.24.41-.24.92-.24S92.34,185.55,92.34,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,185.68c0,.13-.41.24-.92.24s-.92-.11-.92-.24.41-.24.92-.24S96,185.55,96,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.73,185.68c0,.13-.41.24-.92.24s-.93-.11-.93-.24.42-.24.93-.24S99.73,185.55,99.73,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,185.68c0,.13-.42.24-.93.24s-.92-.11-.92-.24.41-.24.92-.24S103.43,185.55,103.43,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.12,185.68c0,.13-.41.24-.92.24s-.93-.11-.93-.24.42-.24.93-.24S107.12,185.55,107.12,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.82,185.68c0,.13-.42.24-.93.24s-.92-.11-.92-.24.41-.24.92-.24S110.82,185.55,110.82,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.51,185.68c0,.13-.41.24-.92.24s-.92-.11-.92-.24.41-.24.92-.24S114.51,185.55,114.51,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.21,185.68c0,.13-.41.24-.92.24s-.93-.11-.93-.24.42-.24.93-.24S118.21,185.55,118.21,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.91,185.68c0,.13-.42.24-.93.24s-.92-.11-.92-.24.41-.24.92-.24S121.91,185.55,121.91,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6,185.68c0,.13-.41.24-.92.24s-.93-.11-.93-.24.42-.24.93-.24S125.6,185.55,125.6,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3,185.68c0,.13-.42.24-.93.24s-.92-.11-.92-.24.41-.24.92-.24S129.3,185.55,129.3,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,185.68c0,.13-.41.24-.92.24s-.92-.11-.92-.24.41-.24.92-.24S133,185.55,133,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.69,185.68c0,.13-.41.24-.93.24s-.92-.11-.92-.24.41-.24.92-.24S136.69,185.55,136.69,185.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,186.32c-.1,0-.19-.27-.23-.64l.23.23h-.28c-.51,0-.92-.11-.92-.24s.41-.24.92-.24h.28l.25,0,0,.21C139.94,186.05,139.85,186.32,139.74,186.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,190c-.13,0-.24-.42-.24-.93s.11-.92.24-.92.24.41.24.92S139.88,190,139.74,190Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,193.71c-.13,0-.24-.41-.24-.92s.11-.93.24-.93.24.42.24.93S139.88,193.71,139.74,193.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,197.41c-.13,0-.24-.42-.24-.93s.11-.92.24-.92.24.41.24.92S139.88,197.41,139.74,197.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,201.1c-.13,0-.24-.41-.24-.92s.11-.92.24-.92.24.41.24.92S139.88,201.1,139.74,201.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,204.8c-.13,0-.24-.41-.24-.93s.11-.92.24-.92.24.41.24.92S139.88,204.8,139.74,204.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,208.49c-.13,0-.24-.41-.24-.92s.11-.92.24-.92.24.41.24.92S139.88,208.49,139.74,208.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,212.19c-.13,0-.24-.41-.24-.92s.11-.93.24-.93.24.42.24.93S139.88,212.19,139.74,212.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,215.89c-.13,0-.24-.42-.24-.93s.11-.92.24-.92.24.41.24.92S139.88,215.89,139.74,215.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,219.58c-.13,0-.24-.41-.24-.92s.11-.93.24-.93.24.42.24.93S139.88,219.58,139.74,219.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,223.28c-.13,0-.24-.42-.24-.93s.11-.92.24-.92.24.41.24.92S139.88,223.28,139.74,223.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,227c-.13,0-.24-.41-.24-.92s.11-.92.24-.92.24.41.24.92S139.88,227,139.74,227Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.36,219.91c0-.13.41-.24.92-.24l-.24.24h0v-.18l0-.17a1.92,1.92,0,0,1,0-.29c0-.17.1-.28.17-.28s.13.11.17.28a1.92,1.92,0,0,1,0,.29l0,.17v.18h0l-.24.24C70.77,220.15,70.36,220,70.36,219.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9,219.91c0-.13.39-.24.87-.24s.86.11.86.24-.39.24-.86.24S66.9,220,66.9,219.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.45,219.91c0-.13.39-.24.87-.24s.86.11.86.24-.39.24-.86.24S63.45,220,63.45,219.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,219.91c0-.13.39-.24.87-.24s.86.11.86.24-.39.24-.86.24S60,220,60,219.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.55,219.91c0-.13.39-.24.86-.24s.87.11.87.24-.39.24-.87.24S56.55,220,56.55,219.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1,219.91c0-.13.39-.24.86-.24s.87.11.87.24-.39.24-.87.24S53.1,220,53.1,219.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.65,219.91c0-.13.39-.24.86-.24s.86.11.86.24-.38.24-.86.24S49.65,220,49.65,219.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2,219.91c0-.13.38-.24.86-.24s.86.11.86.24-.38.24-.86.24S46.2,220,46.2,219.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,219c.13,0,.24.42.24.93l-.24-.24h.18l.18,0,.29.05c.17,0,.27.1.27.17s-.1.12-.27.17l-.29,0h-.36l-.24-.24C43.31,219.4,43.42,219,43.55,219Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,215.26c.13,0,.24.42.24.93s-.11.93-.24.93-.24-.41-.24-.93S43.42,215.26,43.55,215.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,211.54c.13,0,.24.42.24.93s-.11.93-.24.93-.24-.41-.24-.93S43.42,211.54,43.55,211.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,207.83c.13,0,.24.41.24.93s-.11.93-.24.93-.24-.42-.24-.93S43.42,207.83,43.55,207.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,204.11c.13,0,.24.41.24.93s-.11.93-.24.93-.24-.42-.24-.93S43.42,204.11,43.55,204.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,200.39c.13,0,.24.41.24.93s-.11.93-.24.93-.24-.42-.24-.93S43.42,200.39,43.55,200.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,196.67c.13,0,.24.41.24.93s-.11.93-.24.93-.24-.42-.24-.93S43.42,196.67,43.55,196.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.47,193.88c0,.13-.41.24-.92.24l.24-.24h0v.35a2.34,2.34,0,0,1-.05.3c0,.16-.1.27-.17.27s-.13-.11-.17-.27a2.34,2.34,0,0,1-.05-.3l0-.17v-.18h0l.24-.24C44.06,193.64,44.47,193.75,44.47,193.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.92,193.88c0,.13-.38.24-.86.24s-.86-.11-.86-.24.38-.24.86-.24S47.92,193.75,47.92,193.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.37,193.88c0,.13-.38.24-.86.24s-.86-.11-.86-.24.39-.24.86-.24S51.37,193.75,51.37,193.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.83,193.88c0,.13-.39.24-.87.24s-.86-.11-.86-.24.39-.24.86-.24S54.83,193.75,54.83,193.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.28,193.88c0,.13-.39.24-.87.24s-.86-.11-.86-.24.39-.24.86-.24S58.28,193.75,58.28,193.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.73,193.88c0,.13-.39.24-.86.24S60,194,60,193.88s.39-.24.87-.24S61.73,193.75,61.73,193.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.18,193.88c0,.13-.39.24-.86.24s-.87-.11-.87-.24.39-.24.87-.24S65.18,193.75,65.18,193.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.63,193.88c0,.13-.39.24-.86.24s-.87-.11-.87-.24.39-.24.87-.24S68.63,193.75,68.63,193.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.28,194.81c-.13,0-.24-.42-.24-.93.48.48.13.14.24.24h-.19l-.17,0-.29,0c-.17,0-.27-.1-.27-.17s.1-.12.27-.17l.29-.05h.36l.24.24C71.52,194.39,71.41,194.81,71.28,194.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.28,198.53c-.13,0-.24-.42-.24-.93s.11-.93.24-.93.24.41.24.93S71.41,198.53,71.28,198.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.28,202.25c-.13,0-.24-.42-.24-.93s.11-.93.24-.93.24.41.24.93S71.41,202.25,71.28,202.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.28,206c-.13,0-.24-.42-.24-.93s.11-.93.24-.93.24.41.24.93S71.41,206,71.28,206Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.28,209.69c-.13,0-.24-.42-.24-.93s.11-.93.24-.93.24.41.24.93S71.41,209.69,71.28,209.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.28,213.4c-.13,0-.24-.41-.24-.93s.11-.93.24-.93.24.42.24.93S71.41,213.4,71.28,213.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.28,217.12c-.13,0-.24-.41-.24-.93s.11-.93.24-.93.24.42.24.93S71.41,217.12,71.28,217.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.89,
    y: 219.25,
    width: 1.32,
    height: 1.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.89,
    y: 193.22,
    width: 1.32,
    height: 1.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.62,
    y: 193.22,
    width: 1.32,
    height: 1.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.62,
    y: 218.59,
    width: 1.32,
    height: 1.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.09,
    y: 219.25,
    width: 1.32,
    height: 1.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.75,
    y: 193.22,
    width: 1.32,
    height: 1.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.89,
    y: 206.9,
    width: 1.32,
    height: 1.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.96,
    y: 206.23,
    width: 1.32,
    height: 1.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,101.37s0-.33,0-1,0-1.54,0-2.73c0-2.39,0-5.88,0-10.32,0-8.9-.06-21.6-.1-36.92l.18.18-62.48,0h0l.22-.22c0,18.41,0,35.79,0,50.92l-.2-.2,45.13.1,12.79,0,3.39,0,.88,0h-.84l-3.35,0-12.75,0-45.25.1h-.19v-.19c0-15.13,0-32.51,0-50.92v-.22h.22l62.48,0h.18v.18c0,15.37-.07,28.11-.09,37,0,4.43,0,7.9-.05,10.29,0,1.17,0,2.07,0,2.69S211,101.37,211,101.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.48,58c0,.13-14.1.22-31.5.22s-31.5-.09-31.5-.22,14.1-.21,31.5-.21S211.48,57.88,211.48,58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.6,54.29a.84.84,0,0,1-1.68,0,.84.84,0,1,1,1.68,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67,54.29a.84.84,0,1,1-.84-.85A.85.85,0,0,1,156.67,54.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.74,54.29a.85.85,0,1,1-.85-.85A.85.85,0,0,1,159.74,54.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.15,77.19c0,2.71-2,4.34-5.2,4.34h-3.42v4h-1.34V72.83H166C169.18,72.83,171.15,74.47,171.15,77.19Zm-1.35,0c0-2-1.34-3.2-3.89-3.2h-3.38v6.36h3.38C168.46,80.35,169.8,79.19,169.8,77.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.68,72.83V85.55h-1.33V79.68h-8v5.87h-1.34V72.83h1.34V78.5h8V72.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.77,77.19c0,2.71-2,4.34-5.2,4.34h-3.41v4h-1.35V72.83h4.76C196.81,72.83,198.77,74.47,198.77,77.19Zm-1.35,0c0-2-1.34-3.2-3.88-3.2h-3.38v6.36h3.38C196.08,80.35,197.42,79.19,197.42,77.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.8,
    y: 285.11,
    width: 63.56,
    height: 51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.92,292.68c0,.17-8.15.31-28.07.31s-36.08-.14-36.08-.31,16.15-.32,36.08-.32S311.92,292.5,311.92,292.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.64,289a1,1,0,1,1-1-.85A.91.91,0,0,1,253.64,289Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.16,289a.92.92,0,0,1-1,.84.85.85,0,1,1,0-1.69A.92.92,0,0,1,257.16,289Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.67,289a1,1,0,1,1-1-.85A.91.91,0,0,1,260.67,289Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.66,321.5a4.22,4.22,0,0,1,.63-.72l1.83-1.84c1.57-1.54,3.74-3.65,6.17-6l0-.05v.31c-2.44-2.26-4.63-4.33-6.2-5.84l-1.85-1.81a3.79,3.79,0,0,1-.63-.7,3.53,3.53,0,0,1,.75.58l1.93,1.7c1.63,1.46,3.85,3.49,6.29,5.76l.17.16-.16.15-.06,0c-2.42,2.32-4.63,4.39-6.25,5.88l-1.93,1.74A4.1,4.1,0,0,1,288.66,321.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.81,304.88a4.61,4.61,0,0,1-.63.71l-1.84,1.85c-1.56,1.54-3.74,3.65-6.16,6l-.06.05v-.31c2.44,2.27,4.64,4.34,6.21,5.85l1.84,1.81a4.18,4.18,0,0,1,.64.7,4.23,4.23,0,0,1-.75-.58l-1.94-1.71c-1.62-1.45-3.84-3.49-6.29-5.75l-.16-.16.16-.16.06-.05c2.42-2.31,4.63-4.39,6.25-5.87l1.92-1.75A3.56,3.56,0,0,1,269.81,304.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.65,325.42c-.11,0,1.87-5.6,4.42-12.42s4.7-12.31,4.81-12.27-1.87,5.6-4.42,12.42S274.76,325.46,274.65,325.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,395.49A19.61,19.61,0,0,1,122.06,394c2.2.37,4.5,1,6,2.68s1.78,4.57.06,6a5.8,5.8,0,0,1-3.78,1c-3.22,0-6.78-.61-9.35,1.33-1.46,1.1-2.43,2.93-4.18,3.47a4.15,4.15,0,0,1-4.56-2,7,7,0,0,1-.51-5.22A8,8,0,0,1,109.91,395.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.44,379.15c2.26,3.22,6.65,2.16,8.69.19s2.89-4.83,3.68-7.55c1.79-6.22,3.59-12.75,2.26-19.09a10.59,10.59,0,0,0-2.43-5.18,5.55,5.55,0,0,0-5.25-1.75c-2.22.58-3.59,2.75-4.59,4.82a45.49,45.49,0,0,0-4.49,19.52c0,3.14.36,6.44,2.13,9",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.23,383.78c2.46-2.91,2.92-7.16,1.83-10.81a20.79,20.79,0,0,0-6.4-9.28,34.28,34.28,0,0,0-11.46-6.77,12.24,12.24,0,0,0-5.16-.87,5.38,5.38,0,0,0-4.32,2.61c-1.21,2.3,0,5.09,1.2,7.37a86.82,86.82,0,0,0,7.53,11.47c2.25,2.91,4.84,5.77,8.28,7.09s7,1.16,8.83-1.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.29,427.83a7,7,0,0,0,.2-1.46c.1-1.07.23-2.41.39-4a58.69,58.69,0,0,1,.9-5.87,46.62,46.62,0,0,1,2.13-6.92,25.77,25.77,0,0,1,3.54-6.27,13.12,13.12,0,0,1,4.48-3.72,12.72,12.72,0,0,1,3.76-1.18,6.67,6.67,0,0,0,1.46-.21,6.75,6.75,0,0,0-1.48,0,11.24,11.24,0,0,0-3.93,1,13.21,13.21,0,0,0-4.72,3.75,25.22,25.22,0,0,0-3.67,6.4,43.11,43.11,0,0,0-2.12,7,52,52,0,0,0-.78,5.95c-.12,1.7-.17,3.07-.19,4A5.69,5.69,0,0,0,101.29,427.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.56,424.75a2.54,2.54,0,0,0,0-.68v-1.94c0-1.69,0-4.14.08-7.15.15-6,.67-12.54,1.68-21.69,1-8.61,2.22-18.64,3.57-25.15.29-1.48.58-2.82.85-4s.49-2.18.7-3,.34-1.4.46-1.89a3.11,3.11,0,0,0,.11-.67,2.58,2.58,0,0,0-.23.63l-.57,1.87c-.25.81-.5,1.81-.8,3s-.62,2.5-.94,4a222.68,222.68,0,0,0-3.76,23.33c-1,9.18-1.45,17.54-1.49,23.59,0,3,0,5.47.1,7.16q.08,1.19.12,1.95A2.64,2.64,0,0,0,101.56,424.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.6,408.64a12.77,12.77,0,0,0,0-2c-.08-1.3-.26-3.19-.62-5.5a72.05,72.05,0,0,0-1.8-8,65.57,65.57,0,0,0-3.35-9.49A50.66,50.66,0,0,0,86,368.23a27.22,27.22,0,0,0-2.31-2.15c-.36-.3-.67-.6-1-.84l-.9-.62a15.35,15.35,0,0,0-1.71-1.1,63.94,63.94,0,0,1,5.61,5,53.27,53.27,0,0,1,9.6,15.29,74.76,74.76,0,0,1,3.38,9.41,80.67,80.67,0,0,1,1.9,7.94c.42,2.29.67,4.16.81,5.45A13.28,13.28,0,0,0,101.6,408.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.03 437.07 87.64 459.19 116.06 459.19 117.68 437.07 86.03 437.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.28,
    y: 428.35,
    width: 37.79,
    height: 8.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.28 458.35 83.28 460.76 85.06 460.76 120.44 460.76 120.44 458.35 83.28 458.35",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.8 465.02 85.06 460.76 119.09 460.76 117.06 465.02 86.8 465.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.15,444.3a1.08,1.08,0,0,1-.13.2l-.43.57-1.65,2.11-.08.1-.07-.1-4.07-5.63H111c-1.21,1.72-2.56,3.63-4,5.67l-.12.18-.14-.16c-1.48-1.76-3.09-3.67-4.75-5.66h.27l-.26.33-4.25,5.32-.14.18-.13-.18-4-5.67h.24l-4.94,5.62-.09.1-.06-.11L87,444.58l-.39-.69a2,2,0,0,1-.13-.25,1,1,0,0,1,.17.22l.44.67,1.62,2.55-.15,0,4.85-5.69.12-.14.12.15c1.22,1.72,2.58,3.62,4,5.65h-.27l4.23-5.33.26-.33.14-.17.14.17L107,447h-.27l4-5.64.12-.17.12.17,4,5.68h-.14l1.72-2.07.46-.53C117.09,444.35,117.14,444.29,117.15,444.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.07,436.92c0,.1-7.12.18-15.9.18s-15.91-.08-15.91-.18,7.12-.18,15.91-.18S118.07,436.82,118.07,436.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,461c0,.1-7.74.18-17.29.18s-17.28-.08-17.28-.18,7.73-.18,17.28-.18S119.51,460.9,119.51,461Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.42,376.29a31.68,31.68,0,0,0-13.55-4.66c-2.21-.23-4.63-.17-6.41,1.17a1.35,1.35,0,0,0-.66,1.17,1.43,1.43,0,0,0,.63.81,19.39,19.39,0,0,0,20,1.51",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.07,375.91a66.88,66.88,0,0,1-8.75-7.7,22.21,22.21,0,0,1-5.49-10.15,4.11,4.11,0,0,1,.44-3.39c7,5.44,12.45,12.49,13.8,21.24",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.35,376.24a31.46,31.46,0,0,1,.16-11.49,15.48,15.48,0,0,1,6.12-9.48c1.2,2.82.68,6.06-.16,9a44.11,44.11,0,0,1-6.07,12.77",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.18,388.49c-4.15.5-7.76,2.69-10.86,5.5a20.55,20.55,0,0,0-6.22,10.67c4.08-.26,7.53-3.13,10-6.35s4.24-6.75,7-9.76",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.67,390.45a26.8,26.8,0,0,1,3.09-25.35c2.37,8.41,1.5,17.91-3.09,25.35",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.7,401.2a19.61,19.61,0,0,0-10.87,2.55,19.39,19.39,0,0,0-7.65,8.12c-.23.46-.44,1-.13,1.45a1.37,1.37,0,0,0,1.23.36c3.65-.23,6.89-2.43,9.56-4.93s5-5.39,7.94-7.56",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.41,400.62a34.54,34.54,0,0,1-.34-19.28c.68-2.48,1.82-5.09,4.11-6.25a.64.64,0,0,1,1,.35,11.6,11.6,0,0,1,1,5.53,34.32,34.32,0,0,1-.87,5.6c-.72,3.42-1.1,7.09-3,10a19.64,19.64,0,0,0-1.19,2.21c-.36.75-.36,1-.69,1.61",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.33,404.18c-1.77-6.74.11-14.91,4.35-20.43.32-.41.73-.84,1.24-.8.78.07,1,1.12.95,1.9a36.93,36.93,0,0,1-6.54,19.33",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.48,405.66a29.69,29.69,0,0,0,24.39-5,19.82,19.82,0,0,0-13.2-1.62c-4.41,1-8.44,3-11.19,6.59",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.3,401.17c4.59-7.48,13.38-12.36,22.14-12.8-1,3.56-3.94,6.33-7.24,8s-7,2.4-10.63,3.11c-1.41.28-3.35.58-4.27,1.69",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.78,379.39a64.24,64.24,0,0,0,2.83-13A21.45,21.45,0,0,0,410,353.61c-4.28,8.29-4.71,18-.38,26.23",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.2,372.11c5-9.11,15.23-16.38,25.57-17.4-4,9.93-14.86,17.61-25.57,17.4",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.05,373.89c7.47,1.14,13.84,5.91,20.82,8.8a9.31,9.31,0,0,0,4.71.9,3.68,3.68,0,0,0,2.3-6.51,10.14,10.14,0,0,0-3.42-2.08c-7.6-3.16-15.75-3.24-23.76-1.32",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.73,379.13c1.69.48,2.27,1.36,3.61,2.5a38.91,38.91,0,0,0,15.78,8.11c.61.15,1.4.21,1.7-.34s-.07-1-.41-1.47a21.67,21.67,0,0,0-9.53-6.47c-3.65-1.36-6.8-3-11.15-2.64",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,347.48a29.88,29.88,0,0,0,22.9,7.8,1.61,1.61,0,0,0,1.05-.38c.57-.63-.12-1.59-.79-2.12-6.73-5.25-14.89-7.42-23.16-5.3",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.64,345.37a31.91,31.91,0,0,1,28.57-4.72,22.62,22.62,0,0,1-13.61,6,43.14,43.14,0,0,1-15-1.26",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.34,330.83c-.66-6.73-.24-12-.7-18.78,0-.54-.16-1.19-.66-1.39-.7-.27-1.29.6-1.52,1.31a21.52,21.52,0,0,0,2.87,18.71",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.85,331.57A39.57,39.57,0,0,0,426,320.75c2.2-3,4.05-6.62,3.55-10.31a10.65,10.65,0,0,0-8,4,22.55,22.55,0,0,0-4.1,8.24c-.89,2.95-1.51,6-2.56,8.9",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.79,328.53a89.74,89.74,0,0,0,27.4-16.16c-3.27-1.32-7-.53-10.29.79a32.44,32.44,0,0,0-17.25,15.3",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.93,335.25a55.75,55.75,0,0,0,15.21.07c4.94-.83,9.6-2.78,14.21-4.72a1.66,1.66,0,0,0,1-.73,1.11,1.11,0,0,0-.35-1.22,3,3,0,0,0-1.21-.57c-5-1.4-10.41-.74-15.35.92a70.68,70.68,0,0,0-13.47,6.25",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.05,347.71c-3.45-7-3.23-15.09-.25-22.27,2.1,3.2,2.36,7.27,2,11.07s-1.54,7.73-1.61,11.55",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.26,340.76a31.1,31.1,0,0,0-23.08,9.83,21.53,21.53,0,0,0,12.64-2.34A64.16,64.16,0,0,0,375.65,341",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,337.66c-4.21-.34-8.27-.86-12.32.38a14.78,14.78,0,0,0-9.39,8,22.17,22.17,0,0,0,11.55-2.18A66.26,66.26,0,0,0,366,337.66",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.72,337.8c-3.79-2.48-7.69-5-12.1-6s-9.53-.27-12.61,3.06c3.57,2.1,7.91,2.34,12.05,2.34s9.22-.05,13.13,1.33",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.74,338c-6.48-6.36-8.94-17.8-6.33-26.5a40.43,40.43,0,0,1,6.33,26.5",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.56,320c1.23-2.84,2.09-5.83,3.18-8.72a25.07,25.07,0,0,1,4.54-8,12,12,0,0,1,8-4.16,32.29,32.29,0,0,1-15.58,21",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.34,323.73c-2-2.79-4.36-6.57-7.11-8.65s-6.31-3.33-9.66-2.54a22.54,22.54,0,0,0,16.77,11.19",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,320.2a48.11,48.11,0,0,1-3.19-10.36,16.15,16.15,0,0,1,1.62-10.53c3.56,6.73,4.7,13.95,1.75,21",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.6,299.31c2-6.66,8.12-11.57,14.71-13.83a5.46,5.46,0,0,1,2.58-.38,2.22,2.22,0,0,1,1.9,1.58c.24,1.14-.7,2.15-1.58,2.91a49.91,49.91,0,0,1-17.61,9.72",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.67,293.86c.26-4.3.52-8.66,1.92-12.73s4.1-7.9,8-9.68c.66,4.34-1.25,8.66-3.56,12.4s-5.1,7.26-6.49,11.43",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.56,296.82c-1.66-4.86-1.83-11-4.74-15.27-2-2.95-5.3-5-7.05-8.11a12.35,12.35,0,0,0,.41,9.21,26.71,26.71,0,0,0,5.38,7.71c2.16,2.3,4,4,6,6.46",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.6,439.93c-.13,0-.25-32.42-.25-72.4s.08-72.4.21-72.4.25,32.41.25,72.4S397.73,439.93,397.6,439.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.93,342.82a8.13,8.13,0,0,1-1.22.46l-3.36,1.13c-2.83,1-6.71,2.36-10.93,4.09s-8.11,3.24-10.35,5.19a7.5,7.5,0,0,0-2.08,2.75c-.33.76-.38,1.23-.43,1.22a1.1,1.1,0,0,1,0-.34,4.34,4.34,0,0,1,.24-.95,7.15,7.15,0,0,1,2-2.93,17.92,17.92,0,0,1,4.49-2.79c1.8-.84,3.79-1.72,5.9-2.59,4.23-1.73,8.15-3.08,11-4,1.43-.45,2.6-.78,3.4-1A7,7,0,0,1,425.93,342.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.21,320s-.11.14-.34.37l-1,1L430,324.88,417,336.39c-5,4.49-9.41,8.78-12.43,12-1.51,1.61-2.7,2.95-3.51,3.88l-.94,1.07a2.71,2.71,0,0,1-.35.36s.08-.16.27-.42.48-.65.88-1.13c.77-1,1.92-2.34,3.41-4A162.89,162.89,0,0,1,416.71,336c5.06-4.48,9.67-8.5,13-11.41l4-3.41,1.1-.91A2,2,0,0,1,435.21,320Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.57,341c-.13-.06.93-2.49,2-5.57s1.55-5.68,1.69-5.65a19.23,19.23,0,0,1-1.25,5.8,38.19,38.19,0,0,1-1.57,3.89A6,6,0,0,1,411.57,341Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.63,360.58a5,5,0,0,1-.78-.9l-2-2.56c-1.68-2.16-4-5.14-6.58-8.41s-5-6.2-6.7-8.32l-2-2.52a5.13,5.13,0,0,1-.7-1,6.4,6.4,0,0,1,.84.84c.52.57,1.25,1.39,2.15,2.43,1.79,2.06,4.22,5,6.82,8.24s4.87,6.29,6.47,8.5c.81,1.11,1.44,2,1.88,2.65A6.21,6.21,0,0,1,397.63,360.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.41,352.61a11.59,11.59,0,0,1-2.6-4.88,13.88,13.88,0,0,1-.59-4.91l.21,0c-.09.37-.16.57-.2.57s0-.22,0-.6h.21a22.83,22.83,0,0,0,.83,4.78A37.43,37.43,0,0,0,391.41,352.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.4,342.52a8.3,8.3,0,0,0-1.82-1.06,12.2,12.2,0,0,0-5.05-.4,32.29,32.29,0,0,0-5.08.82,13.81,13.81,0,0,1-2.09.5,7.87,7.87,0,0,1,2-.82,23.21,23.21,0,0,1,5.13-1,11,11,0,0,1,5.2.57A3.28,3.28,0,0,1,383.4,342.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.49,340.07c0,.08-1.05-.42-2.78-1a28,28,0,0,0-14-1.07c-1.79.32-2.88.66-2.9.58a2.59,2.59,0,0,1,.74-.31,16.5,16.5,0,0,1,2.1-.59,24.6,24.6,0,0,1,14.2,1.08,17.94,17.94,0,0,1,2,.9C381.27,339.9,381.51,340,381.49,340.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.56,329.74a60.07,60.07,0,0,1-2-7.06,57,57,0,0,1-1.57-7.16,59.51,59.51,0,0,1,2,7.05A56.53,56.53,0,0,1,397.56,329.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.69,329.74a33,33,0,0,0-2.25-4.23,18.37,18.37,0,0,0-3.31-3.41,3,3,0,0,1,1.28.66,10.22,10.22,0,0,1,2.42,2.48A9.3,9.3,0,0,1,397.69,329.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.6,422.65c-.05,0-.15-.78-.51-2.16a31.63,31.63,0,0,0-2.17-5.61,77.82,77.82,0,0,0-11.49-16.19c-2.57-2.94-5.06-5.7-7.17-8.35a57.9,57.9,0,0,1-5.13-7.39,36.56,36.56,0,0,1-2.59-5.49c-.24-.68-.41-1.2-.51-1.57a3,3,0,0,1-.13-.56s.28.74.81,2.06a40.72,40.72,0,0,0,2.71,5.39,61.94,61.94,0,0,0,5.17,7.29c2.12,2.62,4.62,5.37,7.19,8.31,5.19,5.82,9.26,11.7,11.44,16.35a28.62,28.62,0,0,1,2,5.72c.15.7.25,1.25.29,1.62A3.11,3.11,0,0,1,397.6,422.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.2,393.73a12.83,12.83,0,0,1-1.35.76,28.07,28.07,0,0,0-3.48,2.3A40,40,0,0,0,413.8,401c-1.6,1.7-3.25,3.67-4.94,5.78-3.37,4.23-6.52,8-8.41,11a41.58,41.58,0,0,0-2.11,3.61c-.47.87-.71,1.36-.74,1.35s0-.14.12-.38.24-.61.45-1.06a35.57,35.57,0,0,1,2-3.7,120.22,120.22,0,0,1,8.33-11.08c1.69-2.11,3.36-4.08,5-5.77a37.43,37.43,0,0,1,4.69-4.14,24.94,24.94,0,0,1,3.59-2.2c.44-.22.81-.36,1.05-.46A1.42,1.42,0,0,1,423.2,393.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.7,403.11a19.49,19.49,0,0,1-2.84.41,37.36,37.36,0,0,0-6.72,1.33,20.27,20.27,0,0,0-6,3.16c-1.38,1.07-2,2-2.1,1.91s.11-.26.42-.66a11.57,11.57,0,0,1,1.47-1.51A18.5,18.5,0,0,1,414,404.4a31.2,31.2,0,0,1,6.84-1.21A16.57,16.57,0,0,1,423.7,403.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.83,408.89c-.14-.09,1.13-2,2.13-4.66s1.14-5,1.31-5a4.41,4.41,0,0,1,0,1.52,16.46,16.46,0,0,1-.82,3.59,17.72,17.72,0,0,1-1.65,3.28A4.39,4.39,0,0,1,406.83,408.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.49,368.55a2.45,2.45,0,0,1-.46.24l-1.33.61c-.58.25-1.29.56-2.09,1s-1.74.83-2.71,1.42l-1.55.88c-.53.31-1.06.67-1.63,1-1.14.69-2.28,1.54-3.5,2.41a60.14,60.14,0,0,0-13.49,14c-.83,1.25-1.64,2.42-2.29,3.58-.34.58-.68,1.12-1,1.67l-.83,1.57c-.55,1-.95,1.95-1.33,2.76s-.69,1.53-.92,2.12-.41,1-.56,1.36a3.18,3.18,0,0,1-.22.46,1.81,1.81,0,0,1,.13-.5q.19-.54.48-1.38c.21-.61.48-1.34.85-2.16s.74-1.8,1.27-2.8l.81-1.6c.28-.56.62-1.11,1-1.69.64-1.18,1.45-2.37,2.27-3.64A57.94,57.94,0,0,1,418,375.78c1.24-.86,2.4-1.71,3.55-2.39.58-.35,1.11-.71,1.66-1l1.57-.86c1-.57,1.94-1,2.76-1.37a21.75,21.75,0,0,1,2.13-.92l1.37-.53A1.87,1.87,0,0,1,431.49,368.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.23,382.12a3.16,3.16,0,0,1,1.11-1.65,7,7,0,0,1,4.49-1.73,12.2,12.2,0,0,1,4.72.93,6.71,6.71,0,0,1,1.79.86,10.47,10.47,0,0,1-1.9-.55,14.32,14.32,0,0,0-4.6-.77,7.31,7.31,0,0,0-4.28,1.51A12.47,12.47,0,0,0,411.23,382.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,385.25a17.08,17.08,0,0,0,1.27-4.15,17.51,17.51,0,0,0-.28-4.33,2.83,2.83,0,0,1,.52,1.21,8.51,8.51,0,0,1-.72,6.21C408.59,384.91,408.24,385.28,408.2,385.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.21,427.29c.7,12.39,4.43,25,10.17,37.73h25c5.48-12.61,8.95-25.19,9.57-37.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.87,447.34c0,.13-8.22.23-18.36.23s-18.36-.1-18.36-.23,8.22-.24,18.36-.24S415.87,447.21,415.87,447.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.32,451.83c0,.13-7.71.23-17.22.23s-17.21-.1-17.21-.23,7.7-.24,17.21-.24S415.32,451.7,415.32,451.83Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--binary-numbers--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246,140c0-2.42,1.27-3.86,3-3.86s3,1.44,3,3.86-1.28,3.85-3,3.85S246,142.39,246,140Zm5.26,0c0-2-.91-3.15-2.23-3.15S246.8,138,246.8,140s.91,3.14,2.23,3.14S251.26,142,251.26,140Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.18,140c0-2.42,1.26-3.86,3-3.86s3,1.44,3,3.86-1.28,3.85-3,3.85S253.18,142.39,253.18,140Zm5.25,0c0-2-.91-3.15-2.23-3.15S254,138,254,140s.91,3.14,2.23,3.14S258.43,142,258.43,140Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.43,136.18v7.59h-.78v-6.89h-1.79v-.7Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.24,140c0-2.42,1.27-3.86,3-3.86s3,1.44,3,3.86-1.28,3.85-3,3.85S264.24,142.39,264.24,140Zm5.25,0c0-2-.91-3.15-2.23-3.15S265,138,265,140s.91,3.14,2.23,3.14S269.49,142,269.49,140Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.49,136.18v7.59h-.78v-6.89h-1.78v-.7Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.54,150.74c0-2.41,1.26-3.86,3-3.86s3,1.45,3,3.86-1.28,3.86-3,3.86S238.54,153.16,238.54,150.74Zm5.25,0c0-2-.91-3.14-2.23-3.14s-2.23,1.11-2.23,3.14.91,3.14,2.23,3.14S243.79,152.77,243.79,150.74Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.71,150.74c0-2.41,1.27-3.86,3-3.86s3,1.45,3,3.86-1.28,3.86-3,3.86S245.71,153.16,245.71,150.74Zm5.25,0c0-2-.91-3.14-2.23-3.14s-2.23,1.11-2.23,3.14.91,3.14,2.23,3.14S251,152.77,251,150.74Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,147v7.58h-.78v-6.89H252.4V147Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.77,150.74c0-2.41,1.27-3.86,3-3.86s3,1.45,3,3.86-1.28,3.86-3,3.86S256.77,153.16,256.77,150.74Zm5.26,0c0-2-.91-3.14-2.24-3.14s-2.23,1.11-2.23,3.14.91,3.14,2.23,3.14S262,152.77,262,150.74Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,147v7.58h-.79v-6.89h-1.78V147Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.94,147v7.58h-.78v-6.89h-1.79V147Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.75,150.74c0-2.41,1.26-3.86,3-3.86s3,1.45,3,3.86-1.28,3.86-3,3.86S271.75,153.16,271.75,150.74Zm5.25,0c0-2-.91-3.14-2.23-3.14s-2.23,1.11-2.23,3.14.91,3.14,2.23,3.14S277,152.77,277,150.74Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,147v7.58h-.78v-6.89h-1.79V147Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,161.15c0-2.42,1.26-3.86,3-3.86s3,1.44,3,3.86-1.28,3.86-3,3.86S246,163.57,246,161.15Zm5.25,0c0-2-.91-3.14-2.23-3.14s-2.23,1.11-2.23,3.14.91,3.14,2.23,3.14S251.26,163.18,251.26,161.15Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.26,157.36v7.58h-.78v-6.89h-1.79v-.69Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.17,157.36v7.58h-.78v-6.89H256.6v-.69Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.08,157.36v7.58h-.78v-6.89h-1.79v-.69Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.89,161.15c0-2.42,1.27-3.86,3-3.86s3,1.44,3,3.86-1.28,3.86-3,3.86S264.89,163.57,264.89,161.15Zm5.26,0c0-2-.92-3.14-2.24-3.14s-2.23,1.11-2.23,3.14.91,3.14,2.23,3.14S270.15,163.18,270.15,161.15Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,157.36v7.58h-.78v-6.89h-1.78v-.69Z",
    style: {
      fill: "#EF334C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.11,60.58h.51l1.49.05c.33,0,.69,0,1.1,0l1.31.19,1.53.22,1.71.43a29.15,29.15,0,0,1,3.93,1.31l2.15,1c.74.36,1.45.85,2.21,1.29a29.28,29.28,0,0,1,13.48,22,31.26,31.26,0,0,1,.09,4c0,.68,0,1.37-.12,2s-.21,1.37-.31,2.07a29,29,0,0,1-2.75,8.16,29.23,29.23,0,0,1-12.93,12.91c-.73.34-1.44.73-2.2,1l-2.3.85c-.79.22-1.59.41-2.38.62a22.41,22.41,0,0,1-2.45.43c-.41.06-.82.15-1.24.17l-1.25.06a23.56,23.56,0,0,1-2.52.07,28.88,28.88,0,0,1-5.06-.6,29.39,29.39,0,0,1-8.18-3h.24l-9.85,4.69-.45.21.09-.49q1.06-5.59,2.06-10.87l.06.21a29.44,29.44,0,0,1-7-25.45,28.87,28.87,0,0,1,4.4-10.63,29.63,29.63,0,0,1,6.8-7.16,32,32,0,0,1,3.57-2.34c.59-.32,1.19-.57,1.76-.85a10.62,10.62,0,0,1,1.68-.72,23.14,23.14,0,0,1,3.11-1A18.56,18.56,0,0,1,270.1,61c.81-.11,1.53-.24,2.15-.3l1.57-.06,1,0h.32a1.64,1.64,0,0,1-.32,0l-1,.07-1.57.1c-.62.07-1.33.21-2.13.33a19.87,19.87,0,0,0-2.64.6,24.72,24.72,0,0,0-3.08,1,12.43,12.43,0,0,0-1.65.73c-.56.28-1.16.54-1.74.87a31.09,31.09,0,0,0-3.52,2.34,29.56,29.56,0,0,0-6.68,7.11,28.81,28.81,0,0,0-4.29,10.51,29.08,29.08,0,0,0,6.92,25l.08.09,0,.12q-1,5.26-2,10.87l-.36-.27,9.85-4.7.12-.06.11.07a29.12,29.12,0,0,0,8,2.94,28.82,28.82,0,0,0,5,.59c.83,0,1.66,0,2.48-.06l1.23-.07c.41,0,.81-.11,1.22-.16a24.07,24.07,0,0,0,2.4-.42c.79-.21,1.57-.4,2.35-.62l2.26-.82c.74-.29,1.44-.68,2.16-1a30.55,30.55,0,0,0,7.51-5.46,29.94,29.94,0,0,0,5.22-7.22,28.73,28.73,0,0,0,2.73-8c.1-.69.21-1.36.31-2s.08-1.36.13-2a30.46,30.46,0,0,0-.08-3.95,29.15,29.15,0,0,0-13.2-21.77c-.76-.44-1.46-.93-2.19-1.29l-2.11-1a32.91,32.91,0,0,0-3.89-1.34l-1.7-.44L279.5,61l-1.31-.21c-.4,0-.76-.05-1.09-.08l-1.48-.1A5,5,0,0,1,275.11,60.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.82,97.38a3,3,0,0,1,.52-.59l1.5-1.51c1.28-1.26,3.06-3,5-4.88l0,0v.26c-2-1.86-3.79-3.55-5.08-4.79l-1.51-1.47a3.22,3.22,0,0,1-.52-.58,3,3,0,0,1,.61.48L285,85.65c1.33,1.19,3.14,2.85,5.14,4.71l.14.13-.14.12,0,0c-2,1.89-3.79,3.59-5.11,4.8l-1.58,1.43A4,4,0,0,1,282.82,97.38Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.81,97.64a.24.24,0,0,1-.17-.09c-.19-.2-.07-.33.52-.93l1.5-1.51c1.26-1.25,2.95-2.88,4.77-4.62-1.81-1.68-3.48-3.26-4.75-4.48l-1.51-1.48c-.6-.6-.72-.72-.53-.92s.33-.08,1,.46l1.58,1.39c1.38,1.24,3.21,2.91,5.15,4.72l.14.12a.25.25,0,0,1,.08.18.27.27,0,0,1-.08.19l-.13.13c-1.95,1.85-3.76,3.56-5.16,4.85l-1.58,1.42C283.15,97.47,283,97.64,282.81,97.64Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.41,83.78a4.13,4.13,0,0,1-.52.59l-1.5,1.5c-1.28,1.27-3.06,3-5,4.88l-.05,0v-.26c2,1.86,3.79,3.55,5.08,4.78l1.5,1.48a3.64,3.64,0,0,1,.53.58,4,4,0,0,1-.62-.48c-.43-.38-1-.84-1.58-1.4-1.33-1.19-3.15-2.85-5.15-4.7l-.13-.13.13-.13.05,0c2-1.89,3.79-3.59,5.11-4.81l1.57-1.42A3.16,3.16,0,0,1,267.41,83.78Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.42,97.64c-.15,0-.34-.17-.79-.55L265,95.69c-1.4-1.25-3.22-2.93-5.15-4.71l-.13-.13a.23.23,0,0,1-.08-.18.24.24,0,0,1,.07-.18l.14-.13c2-1.88,3.79-3.59,5.16-4.85l1.58-1.43c.63-.56.77-.67,1-.47s.06.32-.52.93l-1.5,1.51c-1.27,1.25-2.95,2.88-4.77,4.61,1.81,1.68,3.48,3.26,4.75,4.48l1.51,1.48c.59.6.72.73.53.93A.24.24,0,0,1,267.42,97.64Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.36,100.58c-.09,0,1.53-4.58,3.62-10.16s3.85-10.07,3.94-10S277.39,85,275.3,90.55,271.45,100.61,271.36,100.58Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.4,100.85a.28.28,0,0,1-.12,0h0c-.29-.1-.4-.15,3.46-10.47,3.75-10,4-10.14,4.07-10.18a.25.25,0,0,1,.19,0c.29.11.4.15-3.46,10.48-1,2.7-2,5.23-2.72,7.13C271.77,100.43,271.6,100.85,271.4,100.85Z",
    style: {
      fill: "#EF334C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.5,
    y: 190.06,
    width: 86.66,
    height: 35.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.16,225.26s0-.21,0-.63,0-1,0-1.82c0-1.61,0-4,0-7,0-6.07,0-14.86-.05-25.74l.09.1-86.65,0h0l.14-.14v35.2l-.14-.13,62.14.06,18,0h.06l-18,0-62.23.06h-.13V189.92h.14l86.65.05h.1v.09c0,10.9,0,19.71-.05,25.8,0,3,0,5.38,0,7,0,.79,0,1.4,0,1.81S425.16,225.26,425.16,225.26Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.87,
    y: 198.12,
    width: 20.93,
    height: 20.93,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.17,206.14c0,.07-10.77.14-24.06.14s-24.06-.07-24.06-.14,10.77-.14,24.06-.14S419.17,206.06,419.17,206.14Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.17,210.4c0,.08-10.77.14-24.06.14s-24.06-.06-24.06-.14,10.77-.13,24.06-.13S419.17,210.33,419.17,210.4Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,214.67a1.34,1.34,0,0,1-.32,0l-.9,0-3.32,0-10.95,0-11,0-3.32,0-.9,0a1.34,1.34,0,0,1-.32,0l.32,0,.9,0,3.32,0,11,0,10.95,0,3.32,0,.9,0Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.69,
    y: 119.03,
    width: 91.43,
    height: 60.33,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,179.36s0-.38,0-1.1,0-1.8,0-3.19c0-2.8,0-6.89-.05-12.13,0-10.49-.06-25.54-.11-43.91l.21.21-91.42.05h0L310,119c0,21.47,0,41.89,0,60.33l-.24-.24,65.82.12,18.84.07,5,0,1.3,0h.45l-.42,0h-1.28l-5,0-18.78.06-66,.12h-.24v-.24c0-18.44,0-38.86,0-60.33v-.26h.27l91.42.06h.21v.2c0,18.42-.08,33.52-.1,44,0,5.22,0,9.3-.06,12.09,0,1.37,0,2.43,0,3.15S401.12,179.36,401.12,179.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.54,125.19c0,.14-20.42.26-45.61.26s-45.61-.12-45.61-.26,20.42-.26,45.61-.26S401.54,125,401.54,125.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.65,
    y: 133.88,
    width: 29.13,
    height: 38.4,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.16,135.67c0,.14-9.14.26-20.42.26s-20.42-.12-20.42-.26,9.14-.26,20.42-.26S393.16,135.52,393.16,135.67Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.16,140.47c0,.14-9.14.26-20.42.26s-20.42-.12-20.42-.26,9.14-.26,20.42-.26S393.16,140.33,393.16,140.47Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.16,145.28c0,.14-9.14.26-20.42.26s-20.42-.12-20.42-.26,9.14-.26,20.42-.26S393.16,145.13,393.16,145.28Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.16,150.08c0,.15-9.14.26-20.42.26s-20.42-.11-20.42-.26,9.14-.26,20.42-.26S393.16,149.94,393.16,150.08Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.48,
    y: 154.06,
    width: 16.42,
    height: 18.21,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.79,154.89a97.24,97.24,0,0,1-10,.26,97,97,0,0,1-10-.26,93.66,93.66,0,0,1,10-.26A93.93,93.93,0,0,1,372.79,154.89Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.79,159.69a93.93,93.93,0,0,1-10,.26,93.66,93.66,0,0,1-10-.26,97,97,0,0,1,10-.26A97.24,97.24,0,0,1,372.79,159.69Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.79,165.26a93.93,93.93,0,0,1-10,.26,93.66,93.66,0,0,1-10-.26,97,97,0,0,1,10-.26A97.24,97.24,0,0,1,372.79,165.26Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.27,170.94a93.66,93.66,0,0,1-10,.26,93.93,93.93,0,0,1-10-.26,97.24,97.24,0,0,1,10-.26A97,97,0,0,1,372.27,170.94Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.08,150.34a3.35,3.35,0,0,1,0-.4c0-.28,0-.64,0-1.1,0-1,0-2.39,0-4.16,0-3.58-.06-8.66-.1-14.77l.19.2-25.49,0c-.05,0,.44-.44.23-.23h0v5.43c0,1.79,0,3.54,0,5.25,0,3.43,0,6.69,0,9.73l-.21-.21,18.36.1,5.23.06,1.4,0,.5,0-.45,0-1.36,0-5.19.05-18.49.1h-.21v-.2c0-3,0-6.3,0-9.73,0-1.71,0-3.46,0-5.25v-5.43h0c-.21.2.28-.29.23-.24l25.49,0h.19v.19c0,6.16-.07,11.28-.1,14.9,0,1.74,0,3.12,0,4.11,0,.44,0,.79,0,1.07A2.37,2.37,0,0,1,163.08,150.34Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.82,142.89a14,14,0,0,1-1.59-1.39c-1-.9-2.36-2.21-4-3.77l.3,0-4,4.63-.16.18-.15.17-.17-.14-2.5-2.07h.29c-2.2,2-4.13,3.66-5.51,4.85l-1.63,1.38a2.78,2.78,0,0,1-.63.46,3,3,0,0,1,.52-.57l1.55-1.48c1.33-1.25,3.21-3,5.4-5l.14-.13.15.12,2.51,2.06-.32,0,.17-.19,4.08-4.59.14-.16.16.15c1.6,1.59,2.94,2.94,3.87,3.9A12.75,12.75,0,0,1,159.82,142.89Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.46,135.87s-.14-.15-.4-.38a2.25,2.25,0,0,0-1.29-.57,2.14,2.14,0,0,0-1.83.76,2.05,2.05,0,0,0,1.92,3.33,2.12,2.12,0,0,0,1.58-1.2,2.26,2.26,0,0,0,.15-1.4,3.67,3.67,0,0,1-.13-.54s.17.14.3.49a2.21,2.21,0,0,1,0,1.57,2.38,2.38,0,0,1-1.8,1.5,2.46,2.46,0,0,1-2.33-4,2.41,2.41,0,0,1,2.2-.81,2.25,2.25,0,0,1,1.38.76C146.43,135.66,146.48,135.86,146.46,135.87Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.63,144.77s-.15-.15-.4-.38a2.28,2.28,0,0,0-1.29-.57,2.14,2.14,0,0,0-1.83.76,2.05,2.05,0,0,0,1.92,3.34,2.12,2.12,0,0,0,1.57-1.21,2.27,2.27,0,0,0,.16-1.4c-.07-.34-.17-.52-.13-.54s.17.14.3.49a2.25,2.25,0,0,1,0,1.58,2.39,2.39,0,0,1-1.8,1.49,2.46,2.46,0,0,1-2.32-4,2.41,2.41,0,0,1,2.2-.81,2.24,2.24,0,0,1,1.38.77C134.59,144.56,134.65,144.76,134.63,144.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.34,151.24a2.3,2.3,0,0,1,0,.43c0,.33,0,.75,0,1.26,0,1.16,0,2.76.07,4.75v.14h-.14c-5.27,0-13.56.08-22.86.08h-1.4v-.23c0-7.25,0-13.82.06-18.77v-.17h.17l6.84.07,1.86.05a2.51,2.51,0,0,1,.65,0,4.05,4.05,0,0,1-.65,0l-1.86.05-6.84.07.17-.16c0,5,0,11.52.06,18.77l-.23-.23h1.17c9.3,0,17.59,0,22.86.09l-.15.14c0-2,.05-3.59.07-4.75,0-.51,0-.93,0-1.26A1.28,1.28,0,0,1,150.34,151.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.23,149.08a36.77,36.77,0,0,1-3.69,3.5,36.37,36.37,0,0,1-3.86,3.3,22.86,22.86,0,0,1,3.55-3.65A23.05,23.05,0,0,1,136.23,149.08Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.37,154.21c-.08.09-.77-.35-1.43-1.1s-1-1.49-.92-1.55.62.53,1.26,1.25S141.46,154.11,141.37,154.21Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.3,168.93s0-.32,0-.94,0-1.54,0-2.73c0-2.4,0-5.91,0-10.41,0-9-.06-22-.1-37.86l.18.18-87.08,0h0l.23-.23c0,18.4,0,36,0,51.94l-.21-.21,62.63.1,18,.06,4.8,0h1.67l-.4,0h-1.22l-4.75,0L147,169l-62.77.11H84v-.22c0-16,0-33.54,0-51.94v-.23h.24l87.08,0h.18V117c0,15.94-.07,28.94-.1,38,0,4.48,0,8,0,10.37,0,1.18,0,2.08,0,2.7S171.3,168.93,171.3,168.93Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.27,
    y: 129.15,
    width: 26.53,
    height: 1.94,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.72,138.74c0,.12-5.78.23-12.92.23s-12.93-.11-12.93-.23,5.79-.23,12.93-.23S116.72,138.61,116.72,138.74Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.72,143c0,.13-5.78.23-12.92.23s-12.93-.1-12.93-.23,5.79-.23,12.93-.23S116.72,142.91,116.72,143Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.72,147.33c0,.13-5.78.23-12.92.23s-12.93-.1-12.93-.23,5.79-.23,12.93-.23S116.72,147.2,116.72,147.33Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.72,151.63c0,.13-5.78.23-12.92.23s-12.93-.1-12.93-.23,5.79-.23,12.93-.23S116.72,151.5,116.72,151.63Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51,155.84a36.64,36.64,0,0,1-5.82.23,36.64,36.64,0,0,1-5.82-.23,36.64,36.64,0,0,1,5.82-.23A36.64,36.64,0,0,1,102.51,155.84Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.22,250.61c0,.08-11.31.14-25.26.14s-25.27-.06-25.27-.14,11.31-.15,25.27-.15S358.22,250.53,358.22,250.61Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.22,255.09c0,.08-11.31.14-25.26.14s-25.27-.06-25.27-.14,11.31-.15,25.27-.15S358.22,255,358.22,255.09Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.22,259.56l-.33,0-.95,0-3.49.05-11.49,0-11.5,0-3.49-.05-1,0-.33,0a1.25,1.25,0,0,1,.33,0l1,0,3.49-.05,11.5,0,11.49,0,3.49.05.95,0A1.25,1.25,0,0,1,340.22,259.56Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.9,271.24c0-.12.37-.21.81-.21s.82.09.82.21-.37.21-.82.21S362.9,271.35,362.9,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.66,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S359.66,271.35,359.66,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.41,271.24c0-.12.37-.21.81-.21s.81.09.81.21-.36.21-.81.21S356.41,271.35,356.41,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.17,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S353.17,271.35,353.17,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.92,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S349.92,271.35,349.92,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.68,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S346.68,271.35,346.68,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.43,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S343.43,271.35,343.43,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.19,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S340.19,271.35,340.19,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.94,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S336.94,271.35,336.94,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.7,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.37.21-.81.21S333.7,271.35,333.7,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.45,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S330.45,271.35,330.45,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.2,271.24c0-.12.37-.21.82-.21s.81.09.81.21-.37.21-.81.21S327.2,271.35,327.2,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S324,271.35,324,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.71,271.24c0-.12.37-.21.82-.21s.81.09.81.21-.37.21-.81.21S320.71,271.35,320.71,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.47,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S317.47,271.35,317.47,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.22,271.24c0-.12.37-.21.82-.21s.81.09.81.21-.37.21-.81.21S314.22,271.35,314.22,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S311,271.35,311,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.73,271.24c0-.12.37-.21.81-.21s.82.09.82.21-.37.21-.82.21S307.73,271.35,307.73,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.49,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S304.49,271.35,304.49,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.24,271.24c0-.12.37-.21.81-.21s.82.09.82.21-.37.21-.82.21S301.24,271.35,301.24,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S298,271.35,298,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.75,271.24c0-.12.37-.21.81-.21s.82.09.82.21-.37.21-.82.21S294.75,271.35,294.75,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.51,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S291.51,271.35,291.51,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.26,271.24c0-.12.37-.21.81-.21s.81.09.81.21-.36.21-.81.21S288.26,271.35,288.26,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S285,271.35,285,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.77,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S281.77,271.35,281.77,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.53,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S278.53,271.35,278.53,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.28,271.24c0-.12.36-.21.81-.21s.81.09.81.21-.36.21-.81.21S275.28,271.35,275.28,271.24Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.51,269.76c.12,0,.22.36.22.81a1.93,1.93,0,0,1-.1.67l-.12-.12q.15,0,.15.12s-.05.08-.15.12l-.06,0-.06-.14a2.25,2.25,0,0,1-.09-.67C273.3,270.12,273.4,269.76,273.51,269.76Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.51,
    cy: 267.32,
    rx: 0.21,
    ry: 0.81,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.51,
    cy: 264.08,
    rx: 0.21,
    ry: 0.81,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.51,
    cy: 260.83,
    rx: 0.21,
    ry: 0.81,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.51,
    cy: 257.59,
    rx: 0.21,
    ry: 0.81,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.51,
    cy: 254.34,
    rx: 0.21,
    ry: 0.81,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.51,
    cy: 251.1,
    rx: 0.21,
    ry: 0.81,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.51,247c.12,0,.22.37.22.81s-.1.81-.22.81-.21-.36-.21-.81S273.4,247,273.51,247Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.51,
    cy: 244.61,
    rx: 0.21,
    ry: 0.81,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.51,
    cy: 241.36,
    rx: 0.21,
    ry: 0.81,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.51,
    cy: 238.12,
    rx: 0.21,
    ry: 0.81,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.22,234.77c0,.11-.31.19-.71.21l.21-.21v.1c0,.45-.1.81-.22.81s-.21-.36-.21-.81v-.32h.2C273.91,234.57,274.22,234.66,274.22,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.47,234.77c0,.11-.37.21-.81.21s-.82-.1-.82-.21.37-.21.82-.21S277.47,234.65,277.47,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.71,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S280.71,234.65,280.71,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,234.77c0,.11-.37.21-.81.21s-.82-.1-.82-.21.37-.21.82-.21S284,234.65,284,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.2,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S287.2,234.65,287.2,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.45,234.77c0,.11-.37.21-.81.21s-.82-.1-.82-.21.37-.21.82-.21S290.45,234.65,290.45,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.69,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S293.69,234.65,293.69,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.94,234.77c0,.11-.37.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S296.94,234.65,296.94,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.18,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S300.18,234.65,300.18,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.43,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S303.43,234.65,303.43,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.67,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S306.67,234.65,306.67,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.92,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S309.92,234.65,309.92,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.16,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S313.16,234.65,313.16,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.41,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S316.41,234.65,316.41,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.65,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.37-.21.81-.21S319.65,234.65,319.65,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.9,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S322.9,234.65,322.9,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.14,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.37-.21.81-.21S326.14,234.65,326.14,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.39,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S329.39,234.65,329.39,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.64,234.77c0,.11-.37.21-.82.21s-.81-.1-.81-.21.37-.21.81-.21S332.64,234.65,332.64,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.88,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S335.88,234.65,335.88,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.13,234.77c0,.11-.37.21-.82.21s-.81-.1-.81-.21.37-.21.81-.21S339.13,234.65,339.13,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.37,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S342.37,234.65,342.37,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.62,234.77c0,.11-.37.21-.81.21s-.82-.1-.82-.21.37-.21.82-.21S345.62,234.65,345.62,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.86,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S348.86,234.65,348.86,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.11,234.77c0,.11-.37.21-.81.21s-.82-.1-.82-.21.37-.21.82-.21S352.11,234.65,352.11,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.35,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S355.35,234.65,355.35,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.6,234.77c0,.11-.37.21-.81.21s-.82-.1-.82-.21.37-.21.82-.21S358.6,234.65,358.6,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.84,234.77c0,.11-.36.21-.81.21s-.81-.1-.81-.21.36-.21.81-.21S361.84,234.65,361.84,234.77Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,235.33c-.1,0-.18-.23-.21-.56l.2.2h-.24c-.45,0-.81-.1-.81-.21s.36-.21.81-.21h.24l.22,0v.18C364.7,235.1,364.62,235.33,364.53,235.33Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,238.58c-.12,0-.22-.37-.22-.82s.1-.81.22-.81.21.37.21.81S364.64,238.58,364.53,238.58Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,241.82c-.12,0-.22-.36-.22-.81s.1-.81.22-.81.21.36.21.81S364.64,241.82,364.53,241.82Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,245.07c-.12,0-.22-.37-.22-.81s.1-.82.22-.82.21.37.21.82S364.64,245.07,364.53,245.07Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,248.31c-.12,0-.22-.36-.22-.81s.1-.81.22-.81.21.36.21.81S364.64,248.31,364.53,248.31Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,251.56c-.12,0-.22-.37-.22-.81s.1-.82.22-.82.21.37.21.82S364.64,251.56,364.53,251.56Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,254.8c-.12,0-.22-.36-.22-.81s.1-.81.22-.81.21.36.21.81S364.64,254.8,364.53,254.8Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,258.05c-.12,0-.22-.37-.22-.81s.1-.82.22-.82.21.37.21.82S364.64,258.05,364.53,258.05Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,261.29c-.12,0-.22-.36-.22-.81s.1-.81.22-.81.21.36.21.81S364.64,261.29,364.53,261.29Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,264.54c-.12,0-.22-.37-.22-.81s.1-.81.22-.81.21.36.21.81S364.64,264.54,364.53,264.54Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,267.78c-.12,0-.22-.36-.22-.81s.1-.81.22-.81.21.36.21.81S364.64,267.78,364.53,267.78Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,271c-.12,0-.22-.37-.22-.81s.1-.81.22-.81.21.36.21.81S364.64,271,364.53,271Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,264.82c0-.11.36-.21.81-.21l-.21.21h0v-.29a1.5,1.5,0,0,1,.05-.26c0-.15.09-.24.15-.24s.11.09.15.24a1.59,1.59,0,0,1,0,.26l0,.15v.14h0c-.09.1.21-.21-.21.22C304,265,303.6,264.94,303.6,264.82Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.57,264.82c0-.11.34-.21.75-.21s.76.1.76.21-.34.22-.76.22S300.57,264.94,300.57,264.82Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.54,264.82c0-.11.34-.21.75-.21s.76.1.76.21-.34.22-.76.22S297.54,264.94,297.54,264.82Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.51,264.82c0-.11.34-.21.75-.21s.76.1.76.21-.34.22-.76.22S294.51,264.94,294.51,264.82Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.48,264.82c0-.11.34-.21.75-.21s.76.1.76.21-.34.22-.76.22S291.48,264.94,291.48,264.82Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.45,264.82c0-.11.33-.21.75-.21s.76.1.76.21-.34.22-.76.22S288.45,264.94,288.45,264.82Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.42,264.82c0-.11.33-.21.75-.21s.76.1.76.21-.34.22-.76.22S285.42,264.94,285.42,264.82Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.39,264.82c0-.11.33-.21.75-.21s.76.1.76.21-.34.22-.76.22S282.39,264.94,282.39,264.82Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.06,264c.12,0,.21.37.21.81l-.21-.21h.31l.26,0c.15,0,.24.1.24.15s-.09.12-.24.15l-.26,0h-.31c-.1-.1.21.21-.21-.22C279.85,264.38,279.94,264,280.06,264Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.06,260.75c.12,0,.21.36.21.81s-.09.82-.21.82-.21-.37-.21-.82S279.94,260.75,280.06,260.75Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.06,257.48c.12,0,.21.37.21.82s-.09.81-.21.81-.21-.36-.21-.81S279.94,257.48,280.06,257.48Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.06,254.21c.12,0,.21.37.21.82s-.09.82-.21.82-.21-.37-.21-.82S279.94,254.21,280.06,254.21Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.06,251c.12,0,.21.36.21.81s-.09.82-.21.82-.21-.36-.21-.82S279.94,251,280.06,251Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.06,247.68c.12,0,.21.37.21.82s-.09.81-.21.81-.21-.36-.21-.81S279.94,247.68,280.06,247.68Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.06,244.42c.12,0,.21.36.21.81s-.09.82-.21.82-.21-.37-.21-.82S279.94,244.42,280.06,244.42Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.87,242c0,.12-.36.21-.81.21.42-.42.12-.11.21-.21h0v.14l0,.16a1.64,1.64,0,0,1,0,.25c0,.15-.09.24-.15.24s-.11-.09-.15-.24a1.58,1.58,0,0,1-.05-.25V242h0l.21-.21C280.51,241.76,280.87,241.85,280.87,242Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.9,242c0,.12-.34.21-.76.21s-.75-.09-.75-.21.33-.21.75-.21S283.9,241.85,283.9,242Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.93,242c0,.12-.34.21-.76.21s-.75-.09-.75-.21.33-.21.75-.21S286.93,241.85,286.93,242Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,242c0,.12-.34.21-.76.21s-.75-.09-.75-.21.33-.21.75-.21S290,241.85,290,242Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,242c0,.12-.34.21-.76.21s-.75-.09-.75-.21.34-.21.75-.21S293,241.85,293,242Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,242c0,.12-.34.21-.76.21s-.75-.09-.75-.21.34-.21.75-.21S296,241.85,296,242Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.05,242c0,.12-.34.21-.76.21s-.75-.09-.75-.21.34-.21.75-.21S299.05,241.85,299.05,242Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.08,242c0,.12-.34.21-.76.21s-.75-.09-.75-.21.34-.21.75-.21S302.08,241.85,302.08,242Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,242.78c-.12,0-.21-.36-.21-.81.42.42.11.12.21.21h-.32l-.26,0c-.14,0-.23-.09-.23-.15s.09-.11.23-.15l.26,0,.15,0h.17l.21.21C304.62,242.42,304.53,242.78,304.41,242.78Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,246.05c-.12,0-.21-.37-.21-.82s.09-.81.21-.81.21.36.21.81S304.53,246.05,304.41,246.05Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,249.31c-.12,0-.21-.36-.21-.81s.09-.82.21-.82.21.37.21.82S304.53,249.31,304.41,249.31Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,252.58c-.12,0-.21-.36-.21-.82s.09-.81.21-.81.21.36.21.81S304.53,252.58,304.41,252.58Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,255.85c-.12,0-.21-.37-.21-.82s.09-.82.21-.82.21.37.21.82S304.53,255.85,304.41,255.85Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,259.11c-.12,0-.21-.36-.21-.81s.09-.82.21-.82.21.37.21.82S304.53,259.11,304.41,259.11Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,262.38c-.12,0-.21-.37-.21-.82s.09-.81.21-.81.21.36.21.81S304.53,262.38,304.41,262.38Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.48,
    y: 264.24,
    width: 1.16,
    height: 1.16,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.48,
    y: 241.39,
    width: 1.16,
    height: 1.16,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.83,
    y: 241.39,
    width: 1.16,
    height: 1.16,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.83,
    y: 263.66,
    width: 1.16,
    height: 1.16,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.07,
    y: 264.24,
    width: 1.16,
    height: 1.16,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.65,
    y: 241.39,
    width: 1.16,
    height: 1.16,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.48,
    y: 253.4,
    width: 1.16,
    height: 1.16,
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.25,
    y: 252.82,
    width: 1.16,
    height: 1.16,
    style: {
      fill: "#EF334C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.69,218.63h56.38a2.26,2.26,0,0,0,1.65-.73l21.15-23.23a2.25,2.25,0,0,0,.58-1.5V150.76a2.23,2.23,0,0,0-2.23-2.23h-54a2.23,2.23,0,0,0-2.23,2.23v40.58a2.22,2.22,0,0,1-.67,1.59l-22.24,21.88A2.23,2.23,0,0,0,253.69,218.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.09,
    y: 151.19,
    width: 54.41,
    height: 38.72,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.73,192.62c0,.14-12.66.26-28.28.26s-28.29-.12-28.29-.26,12.66-.26,28.29-.26S332.73,192.47,332.73,192.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.31,187.05a8,8,0,0,1,1.74-.1h.26l-.1.1a5.64,5.64,0,0,1,.1-1.47,6.22,6.22,0,0,1,.1,1.47v.11h-.36A7,7,0,0,1,327.31,187.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.31,187.05a5,5,0,0,1,2,0,4.6,4.6,0,0,1-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.31,187.05a5,5,0,0,1,2,0,4.6,4.6,0,0,1-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.31,187.05a5,5,0,0,1,2,0,4.6,4.6,0,0,1-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.31,187.05a5,5,0,0,1,2,0,4.6,4.6,0,0,1-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.31,187.05a5,5,0,0,1,2,0,4.6,4.6,0,0,1-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.31,187.05a5,5,0,0,1,2,0,4.6,4.6,0,0,1-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.31,187.05a5,5,0,0,1,2,0,4.6,4.6,0,0,1-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.31,187.05a5,5,0,0,1,2,0,4.6,4.6,0,0,1-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.31,187.05a5,5,0,0,1,2,0,4.6,4.6,0,0,1-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.31,187.05a5,5,0,0,1,2,0,4.6,4.6,0,0,1-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.31,187.05a5,5,0,0,1,2,0,4.6,4.6,0,0,1-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.31,187.05a5,5,0,0,1,2,0,4.6,4.6,0,0,1-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.28,183.08a2.49,2.49,0,0,1,.1,1,2.45,2.45,0,0,1-.1,1,2.35,2.35,0,0,1-.11-1A2.39,2.39,0,0,1,279.28,183.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.28,179.08a2.49,2.49,0,0,1,.1,1,2.45,2.45,0,0,1-.1,1,2.35,2.35,0,0,1-.11-1A2.39,2.39,0,0,1,279.28,179.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.28,175.08a2.49,2.49,0,0,1,.1,1,2.45,2.45,0,0,1-.1,1,2.35,2.35,0,0,1-.11-1A2.39,2.39,0,0,1,279.28,175.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.28,171.08a2.49,2.49,0,0,1,.1,1,2.45,2.45,0,0,1-.1,1,2.35,2.35,0,0,1-.11-1A2.39,2.39,0,0,1,279.28,171.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.28,167.08a2.49,2.49,0,0,1,.1,1,2.45,2.45,0,0,1-.1,1,2.35,2.35,0,0,1-.11-1A2.39,2.39,0,0,1,279.28,167.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.28,163.08a2.49,2.49,0,0,1,.1,1,2.45,2.45,0,0,1-.1,1,2.35,2.35,0,0,1-.11-1A2.39,2.39,0,0,1,279.28,163.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.54,162.34a4.6,4.6,0,0,1-2,0,5.05,5.05,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.54,162.34a4.6,4.6,0,0,1-2,0,5.05,5.05,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.54,162.34a4.6,4.6,0,0,1-2,0,5.05,5.05,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.54,162.34a4.6,4.6,0,0,1-2,0,5.05,5.05,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.54,162.34a4.6,4.6,0,0,1-2,0,5.05,5.05,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.54,162.34a4.6,4.6,0,0,1-2,0,5.05,5.05,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.54,162.34a4.6,4.6,0,0,1-2,0,5.05,5.05,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.54,162.34a4.6,4.6,0,0,1-2,0,5.05,5.05,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.54,162.34a4.6,4.6,0,0,1-2,0,5.05,5.05,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.54,162.34a4.6,4.6,0,0,1-2,0,5.05,5.05,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.54,162.34a4.6,4.6,0,0,1-2,0,5.05,5.05,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.54,162.34a4.6,4.6,0,0,1-2,0,5.05,5.05,0,0,1,2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.31,163.58a2.39,2.39,0,0,1-.11-1v-.24l.1.11a1.84,1.84,0,0,1-.77-.11,1.75,1.75,0,0,1,.77-.1h.1v.34A2.49,2.49,0,0,1,329.31,163.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.31,167.58a2.39,2.39,0,0,1-.11-1,2.35,2.35,0,0,1,.11-1,2.45,2.45,0,0,1,.1,1A2.49,2.49,0,0,1,329.31,167.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.31,171.58a2.39,2.39,0,0,1-.11-1,2.35,2.35,0,0,1,.11-1,2.45,2.45,0,0,1,.1,1A2.49,2.49,0,0,1,329.31,171.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.31,175.58a2.39,2.39,0,0,1-.11-1,2.35,2.35,0,0,1,.11-1,2.45,2.45,0,0,1,.1,1A2.49,2.49,0,0,1,329.31,175.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.31,179.58a2.39,2.39,0,0,1-.11-1,2.35,2.35,0,0,1,.11-1,2.45,2.45,0,0,1,.1,1A2.49,2.49,0,0,1,329.31,179.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.31,183.58a2.39,2.39,0,0,1-.11-1,2.35,2.35,0,0,1,.11-1,2.45,2.45,0,0,1,.1,1A2.49,2.49,0,0,1,329.31,183.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.28,
    y: 153.23,
    width: 50.03,
    height: 7.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.66 207.19 328.46 194.31 277.63 194.31 264.61 206.8 316.66 207.19",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "152.52 441.43 146.67 463.04 165.67 464.78 169.66 444.2 152.52 441.43",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.22,463a13.7,13.7,0,0,1-2.78-.1c-1.71-.13-4.07-.4-6.67-.73l-6.64-.89a17.28,17.28,0,0,1-2.74-.47,12.18,12.18,0,0,1,2.79.1c1.71.14,4.07.4,6.66.74l6.64.88A15.46,15.46,0,0,1,166.22,463Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "146.67 463.04 165.67 464.78 165.98 463.19 147.22 460.81 146.69 462.83",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.11,462.08a80.66,80.66,0,0,1,1.81-8.28,78.27,78.27,0,0,1,2.24-8.17,80.66,80.66,0,0,1-1.81,8.28A81.34,81.34,0,0,1,156.11,462.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.17,462.88a9,9,0,0,0,.05-4,8.08,8.08,0,0,0-2.08-3.76,7.74,7.74,0,0,0-4.73-2.17,8.12,8.12,0,0,0-5.09,1.15,8.84,8.84,0,0,0-3,3.15,11.27,11.27,0,0,0-1.2,3.85,1.11,1.11,0,0,1,0-.29,7.42,7.42,0,0,1,.05-.82,8.71,8.71,0,0,1,.9-2.89,8.87,8.87,0,0,1,3-3.34,8.32,8.32,0,0,1,5.35-1.26,7.83,7.83,0,0,1,7.07,6.31,7.48,7.48,0,0,1,0,3,5.82,5.82,0,0,1-.23.79C165.23,462.79,165.19,462.88,165.17,462.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,435.63l-1.27,19.2s19.11,6.35,19.22,9.92l-37.34.27.75-30Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.2,452.87a1.52,1.52,0,0,0-1.11,1.7,1.47,1.47,0,0,0,1.68,1.12,1.63,1.63,0,0,0,1.17-1.82,1.53,1.53,0,0,0-1.88-1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.57,465l.08-3,36.06,1a2.59,2.59,0,0,1,1.39,2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.3,454.66c0,.18-.93.24-1.84.8s-1.42,1.31-1.58,1.23.14-1.12,1.26-1.78S230.34,454.5,230.3,454.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.16,456.4c0,.18-.76.46-1.4,1.22s-.85,1.56-1,1.54-.26-1,.55-2S234.17,456.23,234.16,456.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.25,461.15c-.17,0-.4-.88.1-1.87s1.36-1.35,1.44-1.2-.47.67-.87,1.49S236.43,461.14,236.25,461.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.1,450.25c-.08.17-.91-.11-1.94-.07s-1.84.34-1.93.18.7-.79,1.91-.82S230.2,450.11,230.1,450.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "230.7 439.43 230.48 442.86 212.14 442.13 212.22 439.05 230.7 439.43"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M230.29,446.37a3.44,3.44,0,0,1-1.87-.06,8.91,8.91,0,0,1-1.94-.66,9.36,9.36,0,0,1-1-.6,2.44,2.44,0,0,1-.55-.46.79.79,0,0,1-.06-1,1,1,0,0,1,.81-.39,2.34,2.34,0,0,1,.7.11,7.43,7.43,0,0,1,1.15.44,6.52,6.52,0,0,1,1.69,1.18c.84.83,1.12,1.52,1.05,1.55s-.49-.52-1.35-1.21a7.19,7.19,0,0,0-1.64-1,7.75,7.75,0,0,0-1.06-.37c-.39-.11-.73-.12-.83.05s-.05.09,0,.21a1.63,1.63,0,0,0,.41.33,10.2,10.2,0,0,0,1,.6,10,10,0,0,0,1.78.74A15.24,15.24,0,0,1,230.29,446.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,446.63a3.08,3.08,0,0,1-.43-1.82,5.83,5.83,0,0,1,.31-2,6.94,6.94,0,0,1,.51-1.12,1.55,1.55,0,0,1,1.22-.91.89.89,0,0,1,.77.55,2.77,2.77,0,0,1,.17.69,4.39,4.39,0,0,1,0,1.26,4.23,4.23,0,0,1-.85,1.9c-.76.95-1.53,1.14-1.54,1.08s.58-.42,1.17-1.34a4.21,4.21,0,0,0,.64-1.74,3.55,3.55,0,0,0,0-1.08c0-.4-.18-.72-.33-.68s-.51.28-.67.59a5.83,5.83,0,0,0-.5,1,7.12,7.12,0,0,0-.42,1.85C230,445.92,230.14,446.6,230,446.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.96 268.81 174.06 268.38 146.57 448.96 170.18 451.95 200.45 303.48 209.5 452.48 209.53 452.93 235.06 452.48 230.96 268.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.08,283.44a9.87,9.87,0,0,1,1.18-.08l3.42-.12,12.3-.35h.23v.24c0,3.57,0,7.56,0,11.8V295l-.08.08c-.69.62-1.41,1.29-2.15,2-2.19,2-4.3,3.95-6.31,5.78l-.17.15-.16-.15-8.42-7.5-.07-.06v-.09c0-3.59.08-6.53.11-8.65,0-1,0-1.74,0-2.33a5.65,5.65,0,0,1,0-.79,6.34,6.34,0,0,1,0,.86c0,.61,0,1.4.05,2.38,0,2.09.06,5,.1,8.53l-.06-.15,8.48,7.43h-.34l6.3-5.8,2.15-2-.09.2c0-4.24,0-8.23,0-11.8l.24.23-12.16.12h-4.41A1.44,1.44,0,0,1,205.08,283.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.31,282.66a7.47,7.47,0,0,1,1,0l3.07.25,11.06,1,.23,0,0,.23c-.41,3.49-.89,7.46-1.4,11.71v.1l-.08.07-2.45,2-6.06,4.81-.19.16-.16-.2c-2.44-3.09-4.69-5.92-6.61-8.36l-.06-.07v-.08c.48-3.54.87-6.46,1.16-8.57.14-1,.25-1.73.33-2.32a3.4,3.4,0,0,1,.15-.77,7.36,7.36,0,0,1-.07.87c-.06.6-.13,1.39-.23,2.37-.23,2.08-.55,5-.93,8.47l0-.16,6.68,8.31-.35,0,6-4.83,2.46-2-.1.18c.53-4.25,1-8.22,1.46-11.71l.21.26-10.9-1.22-3.1-.37C178.71,282.73,178.32,282.68,178.31,282.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.12,310.07a17.6,17.6,0,0,1-2.58-1.26c-1.57-.81-3.73-1.94-6.14-3.15s-4.62-2.25-6.22-3a19.2,19.2,0,0,1-2.55-1.3,13.4,13.4,0,0,1,2.7,1c1.64.67,3.88,1.67,6.3,2.88s4.56,2.39,6.09,3.29A15.29,15.29,0,0,1,213.12,310.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.38,314.45a5.65,5.65,0,0,1-1.94-.73,16.42,16.42,0,0,1-7.05-7,5.51,5.51,0,0,1-.76-1.93,22.19,22.19,0,0,0,9.75,9.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.45,366.63a3.67,3.67,0,0,1-.26.94A12.39,12.39,0,0,1,227,370a14.42,14.42,0,0,1-15.33,6.47,12.71,12.71,0,0,1-2.54-.81,2.9,2.9,0,0,1-.86-.48,34.06,34.06,0,0,0,3.47.93,14.78,14.78,0,0,0,14.95-6.31C227.94,367.93,228.35,366.59,228.45,366.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,365.09a6.71,6.71,0,0,1-2.17,1,21.22,21.22,0,0,1-5.66.94,30.47,30.47,0,0,1-5.72-.34,9.36,9.36,0,0,1-2.31-.53c0-.18,3.59.51,8,.35a27.15,27.15,0,0,0,5.58-.77C223.83,365.35,224.67,365,224.7,365.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4,366.17a9.38,9.38,0,0,1-2,1.79,22.72,22.72,0,0,1-5.67,3.08,23.06,23.06,0,0,1-6.3,1.38,9.55,9.55,0,0,1-2.67-.06,23.38,23.38,0,0,1,2.63-.31,27.07,27.07,0,0,0,11.8-4.39A25.08,25.08,0,0,1,182.4,366.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.41,366a16.27,16.27,0,0,1-10.3-.82c0-.15,2.29.51,5.13.73S177.39,365.79,177.41,366Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.11,304.72a11,11,0,0,1-2.56,1.16,35.14,35.14,0,0,1-6.56,1.7,36.17,36.17,0,0,1-6.77.44,10.94,10.94,0,0,1-2.8-.31,23.89,23.89,0,0,1,2.8-.06,46.3,46.3,0,0,0,13.21-2.12A23.83,23.83,0,0,1,200.11,304.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.56,298.89c.14,0,.26.45.27,1s-.1,1-.25,1-.26-.44-.27-1S198.41,298.89,198.56,298.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.56,294.89c.14,0,.26.45.25,1s-.12,1-.26,1-.26-.45-.26-1S198.42,294.89,198.56,294.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.64,290.89c.15,0,.25.46.24,1s-.14,1-.29,1-.25-.45-.23-1S198.5,290.89,198.64,290.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,286.9c.15,0,.24.46.22,1s-.16,1-.31,1-.24-.45-.21-1S198.66,286.89,198.8,286.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,282.9c.14,0,.23.47.2,1s-.19,1-.33,1-.23-.46-.19-1S198.9,282.89,199,282.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.35,278.91c.15,0,.23.47.18,1s-.2,1-.34,1-.23-.47-.18-1S199.21,278.9,199.35,278.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.67,275.65c.14,0,.23.31.19.66s-.18.63-.32.61-.23-.31-.19-.66S199.53,275.63,199.67,275.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.5,448c.15,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S167.36,448,167.5,448Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.29,444.07c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S168.15,444,168.29,444.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.07,440.15c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S168.93,440.12,169.07,440.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.86,436.23c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S169.72,436.2,169.86,436.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.64,432.3c.14,0,.17.5.06,1s-.31,1-.45.93-.17-.49-.06-1S170.5,432.28,170.64,432.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,428.38c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S171.29,428.35,171.43,428.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.21,424.46c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S172.07,424.43,172.21,424.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,420.54c.14,0,.16.49.06,1s-.31,1-.46.93-.16-.49,0-1S172.86,420.51,173,420.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.78,416.62c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S173.64,416.59,173.78,416.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.57,412.69c.14,0,.16.49.06,1s-.31.95-.46.92-.16-.49-.06-1S174.43,412.67,174.57,412.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35,408.77c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S175.21,408.74,175.35,408.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14,404.85c.14,0,.16.49.05,1s-.31,1-.45.93-.16-.49-.06-1S176,404.82,176.14,404.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.92,400.93c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S176.78,400.9,176.92,400.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.7,397c.15,0,.17.49.06,1s-.31.95-.45.93-.16-.49-.06-1S177.56,397,177.7,397Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.49,393.08c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S178.35,393.05,178.49,393.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.27,389.16c.15,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S179.13,389.13,179.27,389.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.06,385.24c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S179.92,385.21,180.06,385.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.84,381.32c.14,0,.17.49.06,1s-.31.95-.45.93-.17-.49-.06-1S180.7,381.29,180.84,381.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.63,377.39c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S181.49,377.36,181.63,377.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.41,373.47c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S182.27,373.44,182.41,373.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.2,369.55c.14,0,.16.49.06,1s-.31,1-.45.93-.17-.49-.06-1S183.06,369.52,183.2,369.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,365.63c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S183.84,365.6,184,365.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.77,361.7c.14,0,.16.49.06,1s-.31.95-.46.92-.16-.49-.05-1S184.63,361.68,184.77,361.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.55,357.78c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S185.41,357.75,185.55,357.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.34,353.86c.14,0,.16.49.06,1s-.32,1-.46.93-.16-.49-.06-1S186.2,353.83,186.34,353.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.12,349.94c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S187,349.91,187.12,349.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.91,346c.14,0,.16.49.05,1s-.31.95-.45.93-.16-.49-.06-1S187.76,346,187.91,346Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.69,342.09c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S188.55,342.06,188.69,342.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.47,338.17c.15,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S189.33,338.14,189.47,338.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.26,334.25c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S190.12,334.22,190.26,334.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,330.33c.14,0,.17.49.06,1s-.31.95-.45.93-.17-.49-.06-1S190.9,330.3,191,330.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.83,326.4c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S191.69,326.37,191.83,326.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.61,322.48c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S192.47,322.45,192.61,322.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4,318.56c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S193.26,318.53,193.4,318.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.18,314.64c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S194,314.61,194.18,314.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,310.71c.14,0,.16.49.06,1s-.31.95-.46.93-.16-.49,0-1S194.83,310.69,195,310.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.75,306.79c.14,0,.17.49.06,1s-.31,1-.45.93-.17-.49-.06-1S195.61,306.76,195.75,306.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.18,185.83s6.66-10,6.84-10.07h0s6-10.12,8-10.12,1.28,2.05-.78,5.68a14.38,14.38,0,0,0-2,5.16l4.93,3s3.3-1.27,3.44,1.8a22,22,0,0,1-.57,4.17c-.2,1.1-.7,2.26-1.73,1.85a1.29,1.29,0,0,1-.88-1.23c-.07-1.82.27-2.49,0-2.49s-3.55,9.54-3.55,9.54Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.62,178a9.83,9.83,0,0,1,1.59-.95,3.28,3.28,0,0,1,1.8-.28,1.63,1.63,0,0,1,1,.54,1.65,1.65,0,0,1,.19,1.51,4.81,4.81,0,0,1-.81,1.36",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.37,176a10.77,10.77,0,0,1,1.5-.89,3.06,3.06,0,0,1,1.71-.26,1.53,1.53,0,0,1,.94.5,1.51,1.51,0,0,1,.18,1.43,12.41,12.41,0,0,1-1.53,2",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5,180.2l-9.62,20.57,10.61,10.84L283,196.28s3,.59,4.17-1.38c1.35-2.19,3.12-8.53,3.12-8.53Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.37,179.63a5.29,5.29,0,0,1,1.14-2.84,5,5,0,0,1,1.65-1.46c.5-.27.83-.36.86-.3s-1.15.76-2.09,2.06S283.54,179.7,283.37,179.63Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.05,179.72c-.05.07-.37-.11-.93-.21a3.25,3.25,0,0,0-2.11.32,5.22,5.22,0,0,0-1.56,1.55c-.34.48-.57.78-.63.75s0-.4.32-.94a4.26,4.26,0,0,1,1.62-1.82,3.14,3.14,0,0,1,2.45-.22C293.82,179.36,294.09,179.67,294.05,179.72Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.47,176.82a13,13,0,0,0-2.26,1.32c-1.08,1-1.61,2.07-1.76,2a3.68,3.68,0,0,1,1.41-2.39,4.23,4.23,0,0,1,1.77-.93C290.14,176.71,290.46,176.75,290.47,176.82Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.83,181.26c.14,0,.39.74-.12,1.54s-1.32.92-1.34.78.52-.43.9-1.05S292.68,181.28,292.83,181.26Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.2,185.43s-.33-6.14,1.15-7.53,5.74.06,5.74.06",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.69,175a16.57,16.57,0,0,1-2.2,3.5,16.75,16.75,0,0,1-2.62,3.19,32.69,32.69,0,0,1,4.82-6.69Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,180.62c.15-.82.35-1.78.63-2.9a8.85,8.85,0,0,1,1.22-2.69,13.61,13.61,0,0,1,2.35-2.84,1.14,1.14,0,0,0-.5-2.1c-1,0-3.59,1.81-5.35,5s-2.79-2.46-3.2-4.51-2-8.35-2.73-8.72c-1.07-.55-1.85.5-1.39,2.54s1.41,8.26.31,8.43-3-10.32-3-10.32-.06-2.31-1.33-2.16c-2.29.27.61,11.26.92,12.3.21.72-1,1-1.16.16s-1.72-10.51-4.06-10.25c-1.79.19,2.31,9.06,1.51,11.25s-2.43-7-4.13-6.79c-.64.1-1.1.25.6,5.42.82,2.51,4,14.25,4,14.25l-1.83,9.63,14.61,3.7Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.52,128.48l-.14,47.91,20.55,1,.59-11.65s7.31,1.45,9.19-5.33c1.2-4.33.9-37.81.9-37.81Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.32,126c-3.24.92-3.94,6.22-3.94,6.22l-5.08,11.21c-2.59-2-6.06-1.91-6.72,2.64-.48,3.28,3.61,3.95,3.61,3.95-2.38,4-4,7.32-7.45,11.17-3.75,4.16-5.85,4.58-9.91,4.65h-4.48s-2.2-7.12-6.26-24.93c-4.51-19.75,18.85-17.21,23.18-22.25C220.33,110.41,240.52,123,230.32,126Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,142.74c-3.79-2.55-4.13-9.66-1.92-13.93a13.7,13.7,0,0,1,11.66-7.25,5.82,5.82,0,0,0,1.91-.22,5.2,5.2,0,0,0,2-1.94c3.39-4.4,6.71-8.72,13-8.72a7.17,7.17,0,0,1,4,1,6.27,6.27,0,0,1,2.39,3.16,13.32,13.32,0,0,1,3.68-1.33,4.56,4.56,0,0,1,3.71.9,2.79,2.79,0,0,1,.58,3.55,4.47,4.47,0,0,1,4.47,3.73c.34,2.1-2.68,3.58-3,3.74,0,0,1.65,3.47-2.29,5.54-1.59.84-3.66-.17-3.89-.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.52,147.34a9.6,9.6,0,0,1-1.57,7c-.13-.07.53-1.54,1-3.45S205.37,147.35,205.52,147.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,145a8.69,8.69,0,0,1-.19,3.5,8.47,8.47,0,0,1-1.09,3.34,19.1,19.1,0,0,1,.58-3.43A18.34,18.34,0,0,1,208,145Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.13,137.08c.05.07-.53.5-1.27,1.36a13.06,13.06,0,0,0-2.22,3.83,31.16,31.16,0,0,0-1.22,4.31,7.6,7.6,0,0,1-.51,1.81,6.5,6.5,0,0,1,.14-1.88,21.73,21.73,0,0,1,1.11-4.43,11.17,11.17,0,0,1,2.43-3.89A4,4,0,0,1,215.13,137.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,131.7c.06,0,.27.46.4,1.3a8.61,8.61,0,0,1-1.57,6.24c-.5.67-.91,1-1,.95a17.94,17.94,0,0,0,1.84-4.05A17.63,17.63,0,0,0,218,131.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.48,143.67c-.07.12-.7-.1-1.41-.49s-1.22-.82-1.15-.94.7.09,1.4.49S193.55,143.54,193.48,143.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.41,138.55a2.94,2.94,0,0,1-.59,2.09c-.63,1.05-1.49,1.6-1.57,1.49s.55-.79,1.12-1.76S203.26,138.52,203.41,138.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.46,136.91a4.12,4.12,0,0,1-.91,2.49c-.83,1.25-1.86,1.92-1.94,1.81a21.7,21.7,0,0,1,1.5-2.1A22.85,22.85,0,0,1,206.46,136.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.64,116.85s-.39-.3-1.13-.72a7.56,7.56,0,0,0-3.44-.89,9.15,9.15,0,0,0-5,1.36,12.52,12.52,0,0,0-4.31,4.79,21.52,21.52,0,0,0-1.75,4.5l-.08.3-.27-.15a10.31,10.31,0,0,0-4.59-1.17,10.77,10.77,0,0,0-3.73.56,16,16,0,0,0-3,1.53,2.84,2.84,0,0,1,.69-.61,9,9,0,0,1,2.25-1.21,10.67,10.67,0,0,1,3.85-.7,10.48,10.48,0,0,1,4.81,1.16l-.36.16a21.05,21.05,0,0,1,1.77-4.61,12.62,12.62,0,0,1,4.52-5,9.44,9.44,0,0,1,5.31-1.32,7.32,7.32,0,0,1,3.54,1.09,5.43,5.43,0,0,1,.79.62C221.57,116.74,221.65,116.83,221.64,116.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.45,119.45s.57-.15,1.18.54a2,2,0,0,1,.47,1.5,2.35,2.35,0,0,1-1.19,1.71,3.42,3.42,0,0,1-2.5.34,7.25,7.25,0,0,1-2.58-1.25,24.31,24.31,0,0,0-2.52-1.73,10.37,10.37,0,0,0-3-1.06,12.77,12.77,0,0,0-6.2.42,16.74,16.74,0,0,0-4.58,2.33,47.22,47.22,0,0,0-3.66,3.09,5.59,5.59,0,0,1,.81-1,20.56,20.56,0,0,1,2.63-2.38,16.6,16.6,0,0,1,4.65-2.49,13.09,13.09,0,0,1,6.44-.48,10.92,10.92,0,0,1,3.19,1.14,23.74,23.74,0,0,1,2.55,1.78,7,7,0,0,0,2.4,1.22,3,3,0,0,0,2.21-.24,2,2,0,0,0,1.09-1.43,1.78,1.78,0,0,0-1.36-2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.63,178.73l-25.12,44.92a12.73,12.73,0,0,0,1.94,11.93l-.52-.74a10.75,10.75,0,0,0,8.34,4h.47a10.73,10.73,0,0,0,9.84-6.45l5.89-9Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,175.52c-4.93-2.52-9.79-3.09-15.1-3.24-6.18-.18-14.9-1.05-21.56-.34,0,0-20.3-.62-20.39,15.11l2.68,60.4-4.35,25.89,60.84,1.84-.44-30.54c.75-15.89-.85-38.39-.85-38.39.93-8.55,5.61-12.39,6.27-17.95C237.72,183.39,234.44,177.77,230,175.52Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.89,248.33a5.16,5.16,0,0,1-.9.85,19.89,19.89,0,0,1-2.77,1.9,22.21,22.21,0,0,1-21.37.38,20.93,20.93,0,0,1-2.84-1.8,5.21,5.21,0,0,1-.92-.82c.06-.08,1.41,1.06,3.93,2.29a23,23,0,0,0,21-.37C211.52,249.44,212.82,248.25,212.89,248.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,187.05a3.69,3.69,0,0,1,.07.6c0,.45.06,1,.1,1.71.07,1.55.17,3.68.29,6.28.23,5.36.53,12.66.87,20.72s.7,15.36.94,20.73c.13,2.6.24,4.73.32,6.28,0,.69.05,1.26.07,1.71a2.57,2.57,0,0,1,0,.6,2.49,2.49,0,0,1-.09-.6c0-.44-.1-1-.17-1.7-.15-1.48-.3-3.62-.49-6.27-.36-5.3-.75-12.63-1.09-20.72s-.58-15.43-.72-20.74c0-2.6-.09-4.73-.12-6.29,0-.69,0-1.26,0-1.71A2.58,2.58,0,0,1,173,187.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.22,192.27s-2.3,6.76-2.71,7.67c0,0-5.68,16.42-7.53,27.51l18.16-32.79C168.3,194.68,160.47,192.34,160.22,192.27Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.17,190.29a2.45,2.45,0,0,1-.21.47l-.69,1.32c-.62,1.13-1.53,2.76-2.7,4.75-2.31,4-5.78,9.33-9.29,15.41-1.75,3-3.24,6-4.53,8.79a16.08,16.08,0,0,0-1.77,7.71,12.51,12.51,0,0,0,1.41,5.16c.6,1.12,1.1,1.65,1.06,1.68s-.14-.11-.37-.37a10.07,10.07,0,0,1-.87-1.21,12.14,12.14,0,0,1-1.6-5.24,16.25,16.25,0,0,1,1.7-7.93c1.28-2.78,2.75-5.79,4.52-8.85,3.52-6.1,7-11.4,9.43-15.34l2.83-4.66.78-1.27C169.05,190.43,169.15,190.28,169.17,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.06,207.06,267,197.85l-8.89,15.39s-12.32-17.12-17.91-27.15c-5.15-9.23-11.81-11.71-15-12.38a1.42,1.42,0,0,0-1.7,1.55l4.85,33.29c.61,1.74,10.78,16.47,16.45,23.88,9.48,12.37,23.44,4.45,27.28-4.21C275.08,221.35,279.82,210.91,281.06,207.06Z",
    style: {
      fill: "#EF334C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.15,227.14a9.56,9.56,0,0,1-.27-2.2,43.15,43.15,0,0,0-.68-5.24,17.29,17.29,0,0,0-1.8-4.92c-.66-1.17-1.22-1.8-1.16-1.86a5.29,5.29,0,0,1,1.48,1.67,14.69,14.69,0,0,1,2,5,29,29,0,0,1,.54,5.33A9.27,9.27,0,0,1,262.15,227.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.27,220.26c-.08,0-.15-.72-.5-1.81a10,10,0,0,0-2.25-3.77,5.9,5.9,0,0,0-3.75-2.05A4.89,4.89,0,0,0,258,213a2.24,2.24,0,0,1,1.79-.69,5.79,5.79,0,0,1,4.11,2.06,8.93,8.93,0,0,1,2.23,4A4.1,4.1,0,0,1,266.27,220.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.25,177.82a2.32,2.32,0,0,1-.34.39l-.43.44-.54.65A13.77,13.77,0,0,0,220.5,184a18.41,18.41,0,0,0-.53,7.86,16.9,16.9,0,0,0,1.21,4.51,49,49,0,0,0,2.27,4.52c3.45,6.05,7,11.28,9.56,15.06l3.09,4.44a15.9,15.9,0,0,1,1.12,1.65s-.14-.12-.36-.38-.53-.64-.92-1.15c-.79-1-1.9-2.49-3.23-4.35a177.31,177.31,0,0,1-9.71-15,49,49,0,0,1-2.3-4.58,17.92,17.92,0,0,1-1.21-4.63,18.44,18.44,0,0,1,.66-8,13.31,13.31,0,0,1,2.63-4.75l.58-.63c.18-.15.34-.28.48-.41S224.24,177.8,224.25,177.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.54,251c4.49-2,8-6.74,8.16-11.49a4.73,4.73,0,0,0-1.1-3.56c-1.33-1.31-3.57-1.06-5.22-.2-2.72,1.43-4.5,4.12-6.41,6.52s-4.34,4.77-7.39,5.06a19.32,19.32,0,0,1-3.94-.29,6.67,6.67,0,0,0-3.86.46,3,3,0,0,0-1.6,3.27s5.38,3.34,11,2.95A31.7,31.7,0,0,0,208.54,251Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M224.28,266.27a1.66,1.66,0,0,1-.43.18l-1.26.44c-.55.19-1.23.41-2,.62s-1.69.49-2.71.71a69.28,69.28,0,0,1-7.19,1.32,70.85,70.85,0,0,1-17.86,0,67.51,67.51,0,0,1-7.19-1.28c-1-.21-1.92-.48-2.72-.69s-1.48-.43-2-.61l-1.27-.43a1.88,1.88,0,0,1-.43-.19,2.48,2.48,0,0,1,.47.09l1.29.33c.56.16,1.24.35,2,.53s1.71.42,2.73.61c2,.44,4.45.84,7.17,1.16a81.23,81.23,0,0,0,8.87.5,82.92,82.92,0,0,0,8.87-.55c2.72-.33,5.15-.75,7.17-1.2,1-.19,1.92-.44,2.72-.63s1.48-.37,2-.53l1.29-.35A1.47,1.47,0,0,1,224.28,266.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.12,465c0,.14-97.66.26-218.11.26S31.88,465.16,31.88,465s97.64-.26,218.13-.26S468.12,464.87,468.12,465Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBg2);
export default __webpack_public_path__ + "static/media/home-bg2.d634d4347d5c6faccab530c5602de1e6.svg";
export { ForwardRef as ReactComponent };